<template>
  <div
    class="chart"
    v-if="isRouterAlive"
    v-loading="loadNode"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
  >
    <div class="buttons">
      <el-button-group>
        <el-button
          @click="check_chosen('1')"
          :class="chosen_pick == '1' ? 'chosen' : ''"
          >基本案情</el-button
        >
        <el-button
          @click="check_chosen('2')"
          :class="chosen_pick == '2' ? 'chosen' : ''"
          >当&ensp;事&ensp;人</el-button
        >
        <el-button
          @click="check_chosen('3')"
          :class="chosen_pick == '3' ? 'chosen' : ''"
          >法条引用</el-button
        >
        <el-button
          @click="check_chosen('4')"
          :class="chosen_pick == '4' ? 'chosen' : ''"
          >裁判结果</el-button
        >
      </el-button-group>
    </div>

    <!-- AAA -->
    <!-- <div class="caseType">
      <div v-for="(item, index) in eChars.reason" :key="index" class="case">
        <p>{{ item.name }}</p>
        <img src="../../../../assets/imgs/可视化/择律-刑事案件.png" alt="" />
        <p>{{ item.count }}</p>
      </div>
    </div> -->
    <div class="tsg_s" v-show="chosen_pick == '1'">
      <div class="procedural">
        <div
          class="trial"
          v-loading="loading_0"
          element-loading-text="加载中..."
          element-loading-spinner="el-icon-loading"
        >
          <div class="trialTitle">
            <h3>
              裁定年份
              <span v-if="this.timeYears.length <= 0" style="font-size: 15px"
                >(暂无数据)</span
              >
            </h3>
          </div>
          <!-- <el-divider></el-divider> -->
          <div id="main" style="width: 100%; height: 400px"></div>
        </div>
        <div
          class="paperwork"
          v-loading="loading_1"
          element-loading-text="加载中..."
          element-loading-spinner="el-icon-loading"
        >
          <div class="trialTitle">
            <h3>
              案件类型
              <span
                v-if="this.paperCharts_case.length <= 0"
                style="font-size: 15px"
                >(暂无数据)</span
              >
            </h3>
          </div>
          <!-- <el-divider></el-divider> -->
          <div id="paperworkPie_case" style="width: 100%; height: 400px"></div>
        </div>
      </div>
      <div class="procedural">
        <div
          class="trial"
          v-loading="loading_2"
          element-loading-text="加载中..."
          element-loading-spinner="el-icon-loading"
        >
          <div class="trialTitle">
            <h3>
              审理程序
              <span v-if="this.shenliPie.length <= 0" style="font-size: 15px"
                >(暂无数据)</span
              >
            </h3>
          </div>

          <div id="trialBar" style="width: 100%; height: 500px"></div>
        </div>
        <div
          class="paperwork"
          v-loading="loading_3"
          element-loading-text="加载中..."
          element-loading-spinner="el-icon-loading"
        >
          <div class="trialTitle">
            <h3>
              案由
              <span
                v-if="this.trialKey_brief.length <= 0"
                style="font-size: 15px"
                >(暂无数据)</span
              >
            </h3>
          </div>
          <div id="briefPie" style="width: 100%; height: 500px"></div>
        </div>
      </div>
      <div class="procedural">
        <div
          class="brief"
          v-loading="loading_4"
          element-loading-text="加载中..."
          element-loading-spinner="el-icon-loading"
        >
          <div class="trialTitle">
            <h3>
              文书类型
              <span v-if="this.paperCharts.length <= 0" style="font-size: 15px"
                >(暂无数据)</span
              >
            </h3>
          </div>
          <div id="paperworkPie" style="width: 100%; height: 500px"></div>
        </div>
        <div
          class="reference"
          v-loading="loading_5"
          element-loading-text="加载中..."
          element-loading-spinner="el-icon-loading"
        >
          <div class="trialTitle">
            <h3>
              地域
              <span v-if="this.dataList.length <= 0" style="font-size: 15px"
                >(暂无数据)</span
              >
            </h3>
          </div>
          <!-- <i class="el-icon-refresh-left map_return"></i> -->
          <!-- <el-divider></el-divider> -->

          <div id="china_map" style="width: 100%; height: 500px"></div>
        </div>
      </div>
      <div class="procedural">
        <!-- <div class="brief"  v-loading="loading_6"
          element-loading-text="加载中..."
          element-loading-spinner="el-icon-loading">
          <div class="trialTitle">
            <h3>审理法院  <span v-if="this.trialKey_brief0.length <= 0" style="font-size: 15px">(暂无数据)</span></h3>
          </div>
          <div id="briefPie0" style="width: 100%; height: 500px"></div>
        </div> -->
        <div
          class="brief"
          v-loading="loading_7"
          element-loading-text="加载中..."
          element-loading-spinner="el-icon-loading"
        >
          <div class="trialTitle">
            <h3>
              参照级别
              <span v-if="this.refer_level.length <= 0" style="font-size: 15px"
                >(暂无数据)</span
              >
            </h3>
          </div>
          <!-- <el-divider></el-divider> -->
          <div id="referenceBar" style="width: 100%; height: 500px"></div>
        </div>
        <div
          class="reference"
          v-loading="loading_8"
          element-loading-text="加载中..."
          element-loading-spinner="el-icon-loading"
        >
          <div class="trialTitle">
            <h3>
              诉讼费用
              <span v-if="this.fees_key.length <= 0" style="font-size: 15px"
                >(暂无数据)</span
              >
            </h3>
          </div>
          <!-- <el-divider></el-divider> -->
          <div id="main_fees" style="width: 100%; height: 500px"></div>
        </div>
      </div>

      <div class="procedural">
        <!-- <div class="brief"  v-loading="loading_9"
          element-loading-text="加载中..."
          element-loading-spinner="el-icon-loading">
          <div class="trialTitle">
            <h3>审理法官 <span v-if="this.judge_Key.length <= 0" style="font-size: 15px">(暂无数据)</span></h3>
          </div>
          <div id="briefPie_judge" style="width: 100%; height: 500px"></div>
        </div> -->
      </div>
    </div>

    <div class="tsg_s" v-show="chosen_pick == '2'">
      <div style="display: flex; justify-content: center">
        <el-divider><span class="tit_type">原告方</span></el-divider>
      </div>

      <div class="procedural">
        <div
          class="paperwork"
          v-loading="loading_10"
          element-loading-text="加载中..."
          element-loading-spinner="el-icon-loading"
          style="width: 100%"
        >
          <div class="trialTitle">
            <h3>
              原告类型
              <span v-if="paperCharts_type.length <= 0" style="font-size: 15px"
                >(暂无数据)</span
              >
            </h3>
          </div>
          <!-- <el-divider></el-divider> -->
          <div id="paperworkPie_type" style="width: 100%; height: 400px"></div>
        </div>
      </div>

      <div class="procedural">
        <div
          class="brief"
          v-loading="loading_11"
          element-loading-text="加载中..."
          element-loading-spinner="el-icon-loading"
        >
          <div class="trialTitle">
            <h3>
              原告委托律师<span
                v-if="this.lawyer_key.length <= 0"
                style="font-size: 15px"
                >(暂无数据)</span
              >
            </h3>
          </div>
          <div id="briefPie_lawyer" style="width: 100%; height: 500px"></div>
        </div>
        <div
          class="reference"
          v-loading="loading_12"
          element-loading-text="加载中..."
          element-loading-spinner="el-icon-loading"
        >
          <div class="trialTitle">
            <h3>
              原告委托律所<span
                v-if="this.firms_key.length <= 0"
                style="font-size: 15px"
                >(暂无数据)</span
              >
            </h3>
          </div>
          <div id="briefPie_firms" style="width: 100%; height: 500px"></div>
        </div>
      </div>
      <div class="procedural">
        <!-- <div class="brief"  v-loading="loading_13"
          element-loading-text="加载中..."
          element-loading-spinner="el-icon-loading">
          <div class="trialTitle">
            <h3>个人原告</h3>
          </div>
          <div
            id="briefPie_individual"
            style="width: 100%; height: 500px"
          ></div>
        </div> -->
        <div
          class="reference"
          v-loading="loading_14"
          element-loading-text="加载中..."
          element-loading-spinner="el-icon-loading"
        >
          <div class="trialTitle">
            <h3>
              机构原告
              <span
                v-if="this.institution_key.length <= 0"
                style="font-size: 15px"
                >(暂无数据)</span
              >
            </h3>
          </div>
          <div
            id="briefPie_institution"
            style="width: 100%; height: 500px"
          ></div>
        </div>
      </div>
      <div style="display: flex; justify-content: center">
        <el-divider><span class="tit_type">被告方</span></el-divider>
      </div>
      <div
        class="procedural"
        v-loading="loading_15"
        element-loading-text="加载中..."
        element-loading-spinner="el-icon-loading"
      >
        <div class="paperwork" style="width: 100%">
          <div class="trialTitle">
            <h3>
              被告类型<span
                v-if="this.paperCharts_type_de.length <= 0"
                style="font-size: 15px"
                >(暂无数据)</span
              >
            </h3>
          </div>
          <!-- <el-divider></el-divider> -->
          <div
            id="paperworkPie_type_de"
            style="width: 100%; height: 400px"
          ></div>
        </div>
      </div>

      <div class="procedural">
        <div
          class="brief"
          v-loading="loading_16"
          element-loading-text="加载中..."
          element-loading-spinner="el-icon-loading"
        >
          <div class="trialTitle">
            <h3>
              被告委托律师<span
                v-if="this.lawyer_key_de.length <= 0"
                style="font-size: 15px"
                >(暂无数据)</span
              >
            </h3>
          </div>
          <div id="briefPie_lawyer_de" style="width: 100%; height: 500px"></div>
        </div>
        <div
          class="reference"
          v-loading="loading_17"
          element-loading-text="加载中..."
          element-loading-spinner="el-icon-loading"
        >
          <div class="trialTitle">
            <h3>
              被告委托律所<span
                v-if="this.firms_key_de.length <= 0"
                style="font-size: 15px"
                >(暂无数据)</span
              >
            </h3>
          </div>
          <div id="briefPie_firms_de" style="width: 100%; height: 500px"></div>
        </div>
      </div>
      <div class="procedural">
        <!-- <div class="brief"  v-loading="loading_18"
          element-loading-text="加载中..."
          element-loading-spinner="el-icon-loading">
          <div class="trialTitle">
            <h3>个人被告</h3>
          </div>
          <div
            id="briefPie_individual_de"
            style="width: 100%; height: 500px"
          ></div>
        </div> -->
        <div
          class="reference"
          v-loading="loading_19"
          element-loading-text="加载中..."
          element-loading-spinner="el-icon-loading"
        >
          <div class="trialTitle">
            <h3>
              机构被告<span
                v-if="this.institution_key_de.length <= 0"
                style="font-size: 15px"
                >(暂无数据)</span
              >
            </h3>
          </div>
          <div
            id="briefPie_institution_de"
            style="width: 100%; height: 500px"
          ></div>
        </div>
      </div>
    </div>
    <div class="tsg_s" v-show="chosen_pick == '3'">
      <div class="procedural">
        <div
          class="brief"
          style="width: 100%"
          v-loading="loading_20"
          element-loading-text="加载中..."
          element-loading-spinner="el-icon-loading"
        >
          <div class="trialTitle">
            <h3>
              法条引用
              <span v-if="laws_key.length <= 0" style="font-size: 15px"
                >(暂无数据)</span
              >
            </h3>
          </div>
          <div id="briefPie_laws" style="width: 100%; height: 1000px"></div>
          <!-- <div id="briefPie_laws" style="min-height:600px;" :style="height_Adaptive"></div> -->
        </div>
      </div>
    </div>
    <div class="tsg_s" v-show="chosen_pick == '4'">
      <div class="procedural">
        <div
          class="paperwork"
          v-loading="loading_21"
          element-loading-text="加载中..."
          element-loading-spinner="el-icon-loading"
          style="width: 100%"
        >
          <div class="trialTitle">
            <h3>
              案件终审情况
              <span v-if="paperCharts_Final.length <= 0" style="font-size: 15px"
                >(暂无数据)</span
              >
            </h3>
          </div>
          <!-- <el-divider></el-divider> -->
          <div id="paperworkPie_Final" style="width: 100%; height: 400px"></div>
        </div>
      </div>
      <div class="procedural">
        <div
          class="trial"
          v-loading="loading_22"
          element-loading-text="加载中..."
          element-loading-spinner="el-icon-loading"
          style="width: 100%"
        >
          <div class="trialTitle">
            <h3>
              案件周期情况
              <span v-if="cycle_key.length <= 0" style="font-size: 15px"
                >(暂无数据)</span
              >
            </h3>
          </div>
          <!-- <el-divider></el-divider> -->
          <div id="main_cycle" style="width: 100%; height: 400px"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";

import china from "echarts/map/json/china.json";
echarts.registerMap("china", china);
import Map from "./map.vue";
import axios from "axios";
var provinces = [
  "shanghai",
  "hebei",
  "shanxi",
  "neimenggu",
  "liaoning",
  "jilin",
  "heilongjiang",
  "jiangsu",
  "zhejiang",
  "anhui",
  "fujian",
  "jiangxi",
  "shandong",
  "henan",
  "hubei",
  "hunan",
  "guangdong",
  "guangxi",
  "hainan",
  "sichuan",
  "guizhou",
  "yunnan",
  "xizang",
  "shanxi1",
  "gansu",
  "qinghai",
  "ningxia",
  "xinjiang",
  "beijing",
  "tianjin",
  "chongqing",
  "xianggang",
  "aomen",
  "taiwan",
];
var provincesText = [
  "上海",
  "河北",
  "山西",
  "内蒙古",
  "辽宁",
  "吉林",
  "黑龙江",
  "江苏",
  "浙江",
  "安徽",
  "福建",
  "江西",
  "山东",
  "河南",
  "湖北",
  "湖南",
  "广东",
  "广西",
  "海南",
  "四川",
  "贵州",
  "云南",
  "西藏",
  "陕西",
  "甘肃",
  "青海",
  "宁夏",
  "新疆",
  "北京",
  "天津",
  "重庆",
  "香港",
  "澳门",
  "台湾",
];
// import "echarts/map/js/china.js";
export default {
  props: ["eChars"],
  //   inject: ["reloadCharts"],
  data() {
    return {
      dataCharts: "",
      timeLine: [],
      timeYears: [],
      timeCount: [],
      vintages: false,
      trialBar: [],
      trialKey: [],
      shenliPie: [],
      trialCount: [],
      paperCharts: [],
      briefChart: [],
      shenliShow: true,
      paperKey: [],
      paperContent: [],
      level: [],
      isRouterAlive: true,
      chosen_pick: "1",
      paperCharts_case: [],

      // paperCharts_program:[],
      trialKey_brief: [],
      trialCount_brief: [],
      dataList: [
        // {
        //   name: "南海诸岛",
        //   value: 100,
        //   eventTotal:100,
        //   specialImportant:10,
        //   import:10,
        //   compare:10,
        //   common:40,
        //   specail:20
        // },
        // {
        //   name: "北京",
        //   value: 540,
        //   name_js:""
        // },
        // {
        //   name: "天津",
        //   value: 130
        // },
        // {
        //   name: "上海",
        //   value: 400
        // },
        // {
        //   name: "重庆",
        //   value: 750
        // },
        // {
        //   name: "河北",
        //   value: 130
        // },
        // {
        //   name: "河南",
        //   value: 830
        // },
        // {
        //   name: "云南",
        //   value: 110
        // },
        // {
        //   name: "辽宁",
        //   value: 19
        // },
        // {
        //   name: "黑龙江",
        //   value: 150
        // },
        // {
        //   name: "湖南",
        //   value: 690
        // },
        // {
        //   name: "安徽",
        //   value: 60
        // },
        // {
        //   name: "山东",
        //   value: 39
        // },
        // {
        //   name: "新疆",
        //   value: 4
        // },
        // {
        //   name: "江苏",
        //   value: 31
        // },
        // {
        //   name: "浙江",
        //   value: 104
        // },
        // {
        //   name: "江西",
        //   value: 36
        // },
        // {
        //   name: "湖北",
        //   value: 52
        // },
        // {
        //   name: "广西",
        //   value: 33
        // },
        // {
        //   name: "甘肃",
        //   value: 7
        // },
        // {
        //   name: "山西",
        //   value: 5
        // },
        // {
        //   name: "内蒙古",
        //   value: 778
        // },
        // {
        //   name: "陕西",
        //   value: 22
        // },
        // {
        //   name: "吉林",
        //   value: 4
        // },
        // {
        //   name: "福建",
        //   value: 18
        // },
        // {
        //   name: "贵州",
        //   value: 5
        // },
        // {
        //   name: "广东",
        //   value: 98
        // },
        // {
        //   name: "青海",
        //   value: 1
        // },
        // {
        //   name: "西藏",
        //   value: 0
        // },
        // {
        //   name: "四川",
        //   value: 44
        // },
        // {
        //   name: "宁夏",
        //   value: 4
        // },
        // {
        //   name: "海南",
        //   value: 22
        // },
        // {
        //   name: "台湾",
        //   value: 3
        // },
        // {
        //   name: "香港",
        //   value: 5
        // },
        // {
        //   name: "澳门",
        //   value: 555
        // }
      ],
      map: {},
      refer_level: [],
      trialKey_brief0: [],
      trialCount_brief0: [],

      regional_count: "",

      judge_Key: [],
      judge_Count: [],
      parameter: {},

      fees_key: [],
      fees_count: [],

      laws_key: [],
      laws_count: [],

      height_Adaptive: "",
      paperCharts_Final: [],

      cycle_key: [],
      cycle_count: [],

      paperCharts_type: [],
      individual_key: [],
      individual_count: [],
      institution_key: [],
      institution_count: [],
      lawyer_key: [],
      lawyer_count: [],
      firms_key: [],
      firms_count: [],
      loading: true,

      paperCharts_type_de: [],
      individual_key_de: [],
      individual_count_de: [],
      institution_key_de: [],
      institution_count_de: [],
      lawyer_key_de: [],
      lawyer_count_de: [],
      firms_key_de: [],
      firms_count_de: [],
      loading_0: true,
      loading_1: true,
      loading_2: true,
      loading_3: true,
      loading_4: true,
      loading_5: true,
      loading_6: true,
      loading_7: true,
      loading_8: true,
      loading_9: true,
      loading_10: true,
      loading_11: true,
      loading_12: true,
      loading_13: true,
      loading_14: true,
      loading_15: true,
      loading_16: true,
      loading_17: true,
      loading_18: true,
      loading_19: true,
      loading_20: true,
      loading_21: true,
      loading_22: true,
      loading_23: true,
      if_show: "",
      loadNode: true,
    };
  },
  created() {
    if (this.eChars !== "") {
      this.dataCharts = this.eChars;

      this.data_dispose();
    } else {
    }
    this.parameter = JSON.parse(window.localStorage.getItem("parameter"));
    this.getLaw_data();

    this.litigant_data();
    this.laws_data();
    this.outcome_data();
  },
  methods: {
    getLaw_data() {
      this.judge_Key = [];
      this.judge_Count = [];
      this.fees_key = [];
      this.fees_count = [];
      // this.$http
      //   .post("/judgeaggs", this.parameter)
      //   .then((res) => {
      //     console.log(res);
      //     if (res.data.code == 200) {
      //       res.data.data.forEach((item, index) => {
      //         this.judge_Key.push(item.key);
      //         this.judge_Count.push(item.count);
      //       });
      //       this.myBriefsJudge();
      //     }
      //   })
      //   .catch((error) => {
      //     // console.log(error.data);
      //   });

      this.$http
        .post("/feeaggs", this.parameter)
        .then((res) => {
          // console.log(res);
          if (res.data.code == 200) {
            res.data.data.forEach((item, index) => {
              if (item.key !== "10000<") {
                this.fees_key.push(item.key + "元");
              } else {
                this.fees_key.push("10000元<");
              }

              this.fees_count.push(item.doc_count);
            });

            this.fees_Chart();
            this.loading = false;
          }
        })
        .catch((error) => {
          console.log(error.data);
        });
    },

    // 切换图表模块
    check_chosen(i) {
      // this.loading = true;
      // console.log("a");
      if (this.chosen_pick !== "3") {
        this.height_Adaptive = "";
      }
      if (i !== this.chosen_pick) {
        this.chosen_pick = i;
        // console.log(this.chosen_pick);
        if (this.chosen_pick == "1") {
          this.getLaw_data();
          this.data_dispose();
          this.$nextTick(function () {
            this.data_dispose0();
          });
        } else if (this.chosen_pick == "2") {
          // console.log(this.loading);
          // this.litigant_data();
          // this.loading0 = false;

          this.$nextTick(function () {
            this.Paperwork_type();
            this.Briefs_institution();
            this.Briefs_lawyer();
            this.Briefs_firms();
            this.Paperwork_type_de();
            this.Briefs_institution_de();
            this.Briefs_lawyer_de();
            this.Briefs_firms_de();
          });
        } else if (this.chosen_pick == "3") {
          // this.laws_data();
          this.$nextTick(function () {
            this.Briefs_laws();
          });

          // this.loading = false;
        } else {
          // this.outcome_data();
          this.$nextTick(function () {
            // this.loading = false;
            this.myEcharts_cycle();
            this.Paperwork_Final();
          });
          //
        }
      }
    },
    // 当事人数据
    litigant_data() {
      this.paperCharts_type = [];
      this.individual_key = [];
      this.individual_count = [];
      this.institution_key = [];
      this.institution_count = [];
      this.lawyer_key = [];
      this.lawyer_count = [];
      this.firms_key = [];
      this.firms_count = [];
      this.$http
        .post("/ygaggs", this.parameter)
        .then((res) => {
          // console.log(res);
          if (res.data.code == 200) {
            res.data.data.gr_and_jg_count.forEach((item, index) => {
              let val = {
                value: item.doc_count,
                name: item.key,
              };
              this.paperCharts_type.push(val);
            });

            // this.Paperwork_type();
            res.data.data.role.gr.forEach((item, index) => {
              // console.log("a");
              this.individual_key.push(item.key);
              this.individual_count.push(item.doc_count);
            });

            // // this.Briefs_individual();
            res.data.data.role.jg.forEach((item, index) => {
              this.institution_key.push(item.key);
              this.institution_count.push(item.doc_count);
            });

            // this.Briefs_institution();

            res.data.data.lawer_and_lawfirm.forEach((item, index) => {
              this.lawyer_key.push(item.key);
              this.lawyer_count.push(item.doc_count);
            });
            // this.Briefs_lawyer();

            res.data.data.lawfirm.forEach((item, index) => {
              this.firms_key.push(item.key);
              this.firms_count.push(item.doc_count);
            });
            // this.Briefs_firms();
          }
          this.loading = false;
          this.loadNode = false;
          // console.log(this.loading);
        })
        .catch((error) => {
          console.log(error.data);
        });
      this.$nextTick(function () {});
      // return;
      this.paperCharts_type_de = [];
      this.individual_key_de = [];
      this.individual_count_de = [];
      this.institution_key_de = [];
      this.institution_count_de = [];
      this.lawyer_key_de = [];
      this.lawyer_count_de = [];
      this.firms_key_de = [];
      this.firms_count_de = [];
      this.$http
        .post("/bgaggs", this.parameter)
        .then((res) => {
          // console.log(res);
          if (res.data.code == 200) {
            res.data.data.gr_and_jg_count.forEach((item, index) => {
              let val = {
                value: item.doc_count,
                name: item.key,
              };
              this.paperCharts_type_de.push(val);
            });

            // this.Paperwork_type_de();
            res.data.data.role.gr.forEach((item, index) => {
              // console.log("a");
              this.individual_key_de.push(item.key);
              this.individual_count_de.push(item.doc_count);
            });

            //  // this.Briefs_individual_de();
            res.data.data.role.jg.forEach((item, index) => {
              this.institution_key_de.push(item.key);
              this.institution_count_de.push(item.doc_count);
            });
            // this.Briefs_institution_de();
            res.data.data.lawer_and_lawfirm.forEach((item, index) => {
              this.lawyer_key_de.push(item.key);
              this.lawyer_count_de.push(item.doc_count);
            });
            // this.Briefs_lawyer_de();

            res.data.data.lawfirm.forEach((item, index) => {
              this.firms_key_de.push(item.key);
              this.firms_count_de.push(item.doc_count);
            });
            // this.Briefs_firms_de();
          }
          this.if_show = "1";
          console.log(this.if_show);
        })
        .catch((error) => {
          console.log(error.data);
        });
    },

    // 引用法条数据
    laws_data() {
      this.laws_key = [];
      this.laws_count = [];
      this.$http
        .post("/lawaggs", this.parameter)
        .then((res) => {
          console.log(res.data.data);
          if (res.data.code == 200) {
            // res.data.data.sort((p1, p2) => {
            //   return p2.count - p1.count; // 降序排
            //   // return p1.count-p2.count // 升序排
            // });
            res.data.data.forEach((item, index) => {
              this.laws_key.push(item.key);
              this.laws_count.push(item.count);
            });
            let Adaptive = (res.data.data.length * 60).toString();
            this.height_Adaptive = "width: 100%; height: " + Adaptive + "px;";
            this.$nextTick(function () {
              // this.Briefs_laws();
              this.loading = false;
            });
          }
        })
        .catch((error) => {
          console.log(error.data);
        });
    },

    // 裁判结果数据
    outcome_data() {
      this.paperCharts_Final = [];

      this.cycle_key = [];
      this.cycle_count = [];
      this.$http
        .post("/finalsituation", this.parameter)
        .then((res) => {
          // console.log(res);
          if (res.data.code == 200) {
            res.data.data.line.forEach((item, index) => {
              this.cycle_key.push(item.key);
              this.cycle_count.push(item.doc_count);
            });

            // this.myEcharts_cycle();
            res.data.data.pine.forEach((item, index) => {
              let paper_Final = {
                value: item.count,
                name: item.key,
              };
              this.paperCharts_Final.push(paper_Final);
            });
            // this.Paperwork_Final();
            this.loading = false;
          }
        })
        .catch((error) => {
          console.log(error.data);
        });
    },

    //   window
    // 年份折线图
    myEcharts() {
      // console.log(this.timeYears)

      if (this.timeYears.length <= 0) {
        window.document.getElementById("main").style.height = "0px";
      } else {
      }
      var myChart = this.$echarts.init(window.document.getElementById("main"));
      if (this.timeYears.length > 1) {
        if (this.timeYears[0] > this.timeYears[1]) {
          this.timeYears.reverse();
          this.timeCount.reverse();
        }
      }

      //配置图表
      var option = {
        toolbox: {
          show: true, //是否显示工具栏
          orient: "horizontal", //工具栏icon的布局朝向‘horizontal’'vertical'
          itemSize: 15, //工具栏icon的大小
          itemGap: 10, //工具栏icon每项之间的间隔
          showTitle: false, //是否在鼠标hover的时候显示每个工具的icon标题
          feature: {
            // dataView: { show: true, readOnly: false },

            dataView: {
              show: true,
              right: "5%",
              readOnly: false,
              lang: ["数据视图", "关闭"], // 这里将刷新改成其他用途
              readOnly: true,
              optionToContent(opt) {
                // console.log(opt);
                // return
                const series = opt.series[0].data; // 折线图数据
                const axisData = opt.xAxis[0].data; // 这里看你放的是x轴还是y轴
                let tdHeads =
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">时间</td>' +
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">数量</td>'; // 表头
                let tdBodys = ""; // 数据
                // series.forEach(function (item) {
                //   // 组装表头
                //   tdHeads +=
                //     '<td style="padding: 0 10px">' + item.name + "</td>";
                // });
                let table =
                  '<table id="exportTab" border="1" style="margin-left:20px;border-collapse:collapse;font-size:14px;text-align:center;margin: auto;width: 100%;"><tbody><tr style:"border-bottom: 1px solid #ebeef5;">' +
                  tdHeads +
                  " </tr>";
                for (let i = 0, l = axisData.length; i < l; i++) {
                  // for (let j = 0; j < series.length; j++) {
                  // 组装表数据
                  tdBodys +=
                    "<td  style='width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;'>" +
                    series[i] +
                    " 篇 </td>";
                  // }
                  table +=
                    '<tr><td style="width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;">' +
                    axisData[i] +
                    "年</td>" +
                    tdBodys +
                    "</tr>";
                  tdBodys = "";
                }
                table += "</tbody></table>";
                return table;
              },
              // 重置刷新事件方法
              contentToOption(opt) {
                that.myEcharts();
              },
            },
            saveAsImage: {},
          },
        },
        dataZoom: [
          {
            type: "slider",
            show: true,
            // xAxisIndex: [0],
            // left: "9%",
            // bottom: -5,
            start: 50,
            end: 100, //初始化滚动条
            ValueSpan: 20,
            // minValueSpan: 20, //用于限制窗口大小的最小值,在类目轴上可以设置为 5 表示 5 个类目
            // maxValueSpan: 20, //用于限制窗口大小的最小值,在类目轴上可以设置为 5 表示 5 个类目
            // zoomLock: false,
            filterMode: "empty", //增加这句属性设值
            zoomOnMouseWheel: true,
            borderColor: "#eee", //滑动通道的边框颜色

            fillerColor: "#ddb361", //滑动条颜色
            backgroundColor: "#eee", //未选中的滑动条的颜色
            showDataShadow: false, //是否显示数据阴影 默认auto
            height: 14,
          },
        ],
        title: {
          text: "",
        },
        tooltip: {},
        legend: {
          data: [""],
        },
        xAxis: {
          data: this.timeYears,
        },
        grid: {
          left: "15%",
          // bottom:"35%"
        },
        yAxis: {},
        series: [
          {
            name: "时间",
            type: "line",
            avoidLabelOverlap: true, //对，就是这里avoidLabelOverlap
            itemStyle: {
              normal: {
                color: "#f99362", //改变折线点的颜色
                lineStyle: {
                  color: "#f99362", //改变折线颜色
                },
              },
            },
            data: this.timeCount,
            // showBackground: true,
            // backgroundStyle: {
            //   color: "rgba(180, 180, 180, 0.2)",
            // },
          },
        ],
      };
      myChart.setOption(option, true);
      myChart.on("click", (params) => {
        // console.log(params);
        let msg = {
          type: "time",
          key_as_string: params.name,
        };
        this.$emit("transfer", msg);
        return;
        if (params.componentType === "series") {
          console.log("您点击了我");
        }
      });
      this.loading_0 = false;
    },
    // 审理程序
    myTrials() {
      if (this.shenliPie.length <= 0) {
        window.document.getElementById("trialBar").style.height = "0px";
      }
      var myTrial = this.$echarts.init(
        window.document.getElementById("trialBar")
      );
      //配置图表
      var option = {
        toolbox: {
          show: true, //是否显示工具栏
          orient: "horizontal", //工具栏icon的布局朝向‘horizontal’'vertical'
          itemSize: 15, //工具栏icon的大小
          itemGap: 10, //工具栏icon每项之间的间隔
          showTitle: false, //是否在鼠标hover的时候显示每个工具的icon标题
          feature: {
            dataView: {
              show: true,
              readOnly: false,
              lang: ["数据视图", "关闭"], // 这里将刷新改成其他用途
              readOnly: true,
              optionToContent(opt) {
                // console.log(opt);
                // return
                // const series = opt.series[0].data; // 折线图数据
                const axisData = opt.series[0].data; // 这里看你放的是x轴还是y轴
                let tdHeads =
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">审理程序</td>' +
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">数量</td>'; // 表头
                let tdBodys = ""; // 数据
                // series.forEach(function (item) {
                //   // 组装表头
                //   tdHeads +=
                //     '<td style="padding: 0 10px">' + item.name + "</td>";
                // });
                let table =
                  '<table id="exportTab" border="1" style="margin-left:20px;border-collapse:collapse;font-size:14px;text-align:center;margin: auto;width: 80%;"><tbody><tr style:"border-bottom: 1px solid #ebeef5;">' +
                  tdHeads +
                  " </tr>";
                for (let i = 0, l = axisData.length; i < l; i++) {
                  // for (let j = 0; j < series.length; j++) {
                  // 组装表数据
                  tdBodys +=
                    "<td  style='width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;'>" +
                    axisData[i].value +
                    " 篇 </td>";
                  // }
                  table +=
                    '<tr><td style="width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;">' +
                    axisData[i].name +
                    "</td>" +
                    tdBodys +
                    "</tr>";
                  tdBodys = "";
                }
                table += "</tbody></table>";
                return table;
              },
              // 重置刷新事件方法
              contentToOption(opt) {
                that.myTrials();
              },
            },
            saveAsImage: {},
          },
        },
        title: {
          //   text: "Referer of a Website",
          //   subtext: "Fake Data",
          //   left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          // orient: "vertical",
          // left: "right",
          x: "center",
          y: "bottom",
        },
        // grid: {
        //   // left: "15%",
        //   bottom:"35%"
        // },
        series: [
          {
            // name: "Access From",
            type: "pie",
            radius: ["30%", "60%"],
            center: ["50%", "50%"],
            label: {
              normal: {
                // show: true,
                // position: 'inside',
                formatter: "{b}({d}%)", //模板变量有 {a}、{b}、{c}、{d}，分别表示系列名，数据名，数据值，百分比。{d}数据会根据value值计算百分比
              },
            },
            data: this.shenliPie,
            // emphasis: {
            //   itemStyle: {
            //     shadowBlur: 10,
            //     shadowOffsetX: 0,
            //     shadowColor: "rgba(0, 0, 0, 0.5)",
            //   },
            // },
          },
        ],
      };
      myTrial.setOption(option, true);
      myTrial.on("click", (params) => {
        // console.log(params);
        //  console.log('params');
        // return;
        let msg = {
          type: "procedures",
          key: params.data.name,
          doc_count: params.data.value,
        };
        this.$emit("transfer", msg);
      });
      this.loading_2 = false;
    },
    // 案件类型
    myPaperwork_case() {
      if (this.paperCharts_case.length <= 0) {
        window.document.getElementById("paperworkPie_case").style.height =
          "0px";
      }
      var myPaper_case = this.$echarts.init(
        window.document.getElementById("paperworkPie_case")
      );
      var option = {
        toolbox: {
          show: true, //是否显示工具栏
          orient: "horizontal", //工具栏icon的布局朝向‘horizontal’'vertical'
          itemSize: 15, //工具栏icon的大小
          itemGap: 10, //工具栏icon每项之间的间隔
          showTitle: false, //是否在鼠标hover的时候显示每个工具的icon标题
          feature: {
            dataView: {
              show: true,
              readOnly: false,
              lang: ["数据视图", "关闭"], // 这里将刷新改成其他用途
              readOnly: true,
              optionToContent(opt) {
                // console.log(opt);
                // return
                // const series = opt.series[0].data; // 折线图数据
                const axisData = opt.series[0].data; // 这里看你放的是x轴还是y轴
                let tdHeads =
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">案件类型</td>' +
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">数量</td>'; // 表头
                let tdBodys = ""; // 数据
                // series.forEach(function (item) {
                //   // 组装表头
                //   tdHeads +=
                //     '<td style="padding: 0 10px">' + item.name + "</td>";
                // });
                let table =
                  '<table id="exportTab" border="1" style="margin-left:20px;border-collapse:collapse;font-size:14px;text-align:center;margin: auto;width: 80%;"><tbody><tr style:"border-bottom: 1px solid #ebeef5;">' +
                  tdHeads +
                  " </tr>";
                for (let i = 0, l = axisData.length; i < l; i++) {
                  // for (let j = 0; j < series.length; j++) {
                  // 组装表数据
                  tdBodys +=
                    "<td  style='width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;'>" +
                    axisData[i].value +
                    " 篇 </td>";
                  // }
                  table +=
                    '<tr><td style="width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;">' +
                    axisData[i].name +
                    "</td>" +
                    tdBodys +
                    "</tr>";
                  tdBodys = "";
                }
                table += "</tbody></table>";
                return table;
              },
              // 重置刷新事件方法
              contentToOption(opt) {
                that.myPaperwork_case();
              },
            },
            saveAsImage: {},
          },
        },
        title: {
          //   text: "Referer of a Website",
          //   subtext: "Fake Data",
          //   left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          // orient: "vertical",
          // left: "right",
          x: "center",
          y: "bottom",
        },
        series: [
          {
            // name: "Access From",
            type: "pie",
            radius: ["40%", "70%"],
            label: {
              normal: {
                // show: true,
                // position: 'inside',
                formatter: "{b}({d}%)", //模板变量有 {a}、{b}、{c}、{d}，分别表示系列名，数据名，数据值，百分比。{d}数据会根据value值计算百分比
              },
            },
            data: this.paperCharts_case,
            // emphasis: {
            //   itemStyle: {
            //     shadowBlur: 10,
            //     shadowOffsetX: 0,
            //     shadowColor: "rgba(0, 0, 0, 0.5)",
            //   },
            // },
          },
        ],
      };
      myPaper_case.setOption(option, true);
      myPaper_case.on("click", (params) => {
        // console.log(params);

        let msg = {
          type: "brief",
          name: params.data.name,
          val: params.data.val,
          value: params.data.value,
        };
        this.$emit("transfer", msg);
        return;
        if (params.componentType === "series") {
          console.log("您点击了我");
        }
      });
      this.loading_1 = false;
    },
    // 审理程序
    // 案件类型
    myPaperwork_program() {
      if (this.shenliPie.length <= 0) {
        window.document.getElementById("paperworkPie_program").style.height =
          "0px";
      }
      var myPaper_program = this.$echarts.init(
        window.document.getElementById("paperworkPie_program")
      );
      var option = {
        toolbox: {
          show: true, //是否显示工具栏
          orient: "horizontal", //工具栏icon的布局朝向‘horizontal’'vertical'
          itemSize: 15, //工具栏icon的大小
          itemGap: 10, //工具栏icon每项之间的间隔
          showTitle: false, //是否在鼠标hover的时候显示每个工具的icon标题
          feature: {
            saveAsImage: {},
          },
        },
        title: {
          //   text: "Referer of a Website",
          //   subtext: "Fake Data",
          //   left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          // orient: "vertical",
          // left: "right",
          x: "center",
          y: "bottom",
        },
        series: [
          {
            // name: "Access From",
            type: "pie",
            // radius: ["40%", "70%"],
            radius: "60%",
            // radius: ["10%", "30%"],
            // center: ["50%", "50%"],
            // minAngle: 15, //最小角度
            // startAngle: 270, //起始角度
            // labelLine: {
            //   normal: {
            //     length: 5,
            //   },
            // },
            label: {
              normal: {
                // show: true,
                // position: 'inside',
                length: 5,
                formatter: "{b}({d}%)", //模板变量有 {a}、{b}、{c}、{d}，分别表示系列名，数据名，数据值，百分比。{d}数据会根据value值计算百分比
              },
            },
            data: this.shenliPie,
            // emphasis: {
            //   itemStyle: {
            //     shadowBlur: 10,
            //     shadowOffsetX: 0,
            //     shadowColor: "rgba(0, 0, 0, 0.5)",
            //   },
            // },
          },
        ],
      };
      myPaper_program.setOption(option, true);

      myPaper_program.on("click", (params) => {
        // console.log(params);
        // console.log("params");
        return;
        let msg = {
          type: "procedures",
          key: params.data.name,
          doc_count: params.data.val,
        };
        this.$emit("transfer", msg);

        if (params.componentType === "series") {
          console.log("您点击了我");
        }
      });
    },
    // 文书类型
    myPaperwork() {
      if (this.paperCharts.length <= 0) {
        window.document.getElementById("paperworkPie").style.height = "0px";
      }
      var myPaper = this.$echarts.init(
        window.document.getElementById("paperworkPie")
      );
      var option = {
        title: {
          //   text: "Referer of a Website",
          //   subtext: "Fake Data",
          //   left: "center",
        },
        toolbox: {
          show: true, //是否显示工具栏
          orient: "horizontal", //工具栏icon的布局朝向‘horizontal’'vertical'
          itemSize: 15, //工具栏icon的大小
          itemGap: 10, //工具栏icon每项之间的间隔
          showTitle: false, //是否在鼠标hover的时候显示每个工具的icon标题
          feature: {
            // restore: {},

            dataView: {
              show: true,
              readOnly: false,
              lang: ["数据视图", "关闭"], // 这里将刷新改成其他用途
              readOnly: true,
              optionToContent(opt) {
                // console.log(opt);
                // return
                // const series = opt.series[0].data; // 折线图数据
                const axisData = opt.series[0].data; // 这里看你放的是x轴还是y轴
                let tdHeads =
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">文书类型</td>' +
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">数量</td>'; // 表头
                let tdBodys = ""; // 数据
                // series.forEach(function (item) {
                //   // 组装表头
                //   tdHeads +=
                //     '<td style="padding: 0 10px">' + item.name + "</td>";
                // });
                let table =
                  '<table id="exportTab" border="1" style="margin-left:20px;border-collapse:collapse;font-size:14px;text-align:center;margin: auto;width: 90%;"><tbody><tr style:"border-bottom: 1px solid #ebeef5;">' +
                  tdHeads +
                  " </tr>";
                for (let i = 0, l = axisData.length; i < l; i++) {
                  // for (let j = 0; j < series.length; j++) {
                  // 组装表数据
                  tdBodys +=
                    "<td  style='width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;'>" +
                    axisData[i].value +
                    " 篇 </td>";
                  // }
                  table +=
                    '<tr><td style="width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;">' +
                    axisData[i].name +
                    "</td>" +
                    tdBodys +
                    "</tr>";
                  tdBodys = "";
                }
                table += "</tbody></table>";
                return table;
              },
              // 重置刷新事件方法
              contentToOption(opt) {
                that.myPaperwork();
              },
            },
            saveAsImage: {},
          },
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          // orient: "vertical",
          // left: "right",
          x: "center",
          y: "bottom",
        },
        series: [
          {
            // name: "Access From",
            type: "pie",
            radius: ["30%", "60%"],
            center: ["50%", "50%"],
            label: {
              normal: {
                // show: true,
                // position: 'inside',
                formatter: "{b}({d}%)", //模板变量有 {a}、{b}、{c}、{d}，分别表示系列名，数据名，数据值，百分比。{d}数据会根据value值计算百分比
              },
            },
            data: this.paperCharts,
            // emphasis: {
            //   itemStyle: {
            //     shadowBlur: 10,
            //     shadowOffsetX: 0,
            //     shadowColor: "rgba(0, 0, 0, 0.5)",
            //   },
            // },
          },
        ],
      };
      myPaper.setOption(option, true);
      this.loading_4 = false;
    },

    // 参照级别
    myLevel() {
      if (this.refer_level.length <= 0) {
        window.document.getElementById("referenceBar").style.height = "0px";
      }
      var myGarde = this.$echarts.init(
        window.document.getElementById("referenceBar")
      );
      var option = {
        toolbox: {
          show: true, //是否显示工具栏
          orient: "horizontal", //工具栏icon的布局朝向‘horizontal’'vertical'
          itemSize: 15, //工具栏icon的大小
          itemGap: 10, //工具栏icon每项之间的间隔
          showTitle: false, //是否在鼠标hover的时候显示每个工具的icon标题
          feature: {
            dataView: {
              show: true,
              readOnly: false,
              lang: ["数据视图", "关闭"], // 这里将刷新改成其他用途
              readOnly: true,
              optionToContent(opt) {
                // console.log(opt);
                // return
                // const series = opt.series[0].data; // 折线图数据
                const axisData = opt.series[0].data; // 这里看你放的是x轴还是y轴
                let tdHeads =
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">参照级别</td>' +
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">数量</td>'; // 表头
                let tdBodys = ""; // 数据
                // series.forEach(function (item) {
                //   // 组装表头
                //   tdHeads +=
                //     '<td style="padding: 0 10px">' + item.name + "</td>";
                // });
                let table =
                  '<table id="exportTab" border="1" style="margin-left:20px;border-collapse:collapse;font-size:14px;text-align:center;margin: auto;width: 80%;"><tbody><tr style:"border-bottom: 1px solid #ebeef5;">' +
                  tdHeads +
                  " </tr>";
                for (let i = 0, l = axisData.length; i < l; i++) {
                  // for (let j = 0; j < series.length; j++) {
                  // 组装表数据
                  tdBodys +=
                    "<td  style='width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;'>" +
                    axisData[i].value +
                    " 篇 </td>";
                  // }
                  table +=
                    '<tr><td style="width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;">' +
                    axisData[i].name +
                    "</td>" +
                    tdBodys +
                    "</tr>";
                  tdBodys = "";
                }
                table += "</tbody></table>";
                return table;
              },
              // 重置刷新事件方法
              contentToOption(opt) {
                that.myLevel();
              },
            },
            saveAsImage: {},
          },
        },
        title: {
          //   text: "Referer of a Website",
          //   subtext: "Fake Data",
          //   left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          // orient: "vertical",
          // left: "right",
          x: "center",
          y: "bottom",
        },
        series: [
          {
            // name: "Access From",
            type: "pie",
            radius: ["40%", "70%"],
            label: {
              normal: {
                // show: true,
                // position: 'inside',
                formatter: "{b}({d}%)", //模板变量有 {a}、{b}、{c}、{d}，分别表示系列名，数据名，数据值，百分比。{d}数据会根据value值计算百分比
              },
            },
            data: this.refer_level,
            // emphasis: {
            //   itemStyle: {
            //     shadowBlur: 10,
            //     shadowOffsetX: 0,

            //     shadowColor: "rgba(0, 0, 0, 0.5)",
            //   },
            // },
          },
        ],
      };
      myGarde.setOption(option, true);
      this.loading_7 = false;
    },
    // 案由
    myBriefs() {
      if (this.trialKey_brief.length <= 0) {
        window.document.getElementById("briefPie").style.height = "0px";
      }
      var myBrief = this.$echarts.init(
        window.document.getElementById("briefPie")
      );
      //配置图表
      var option = {
        toolbox: {
          show: true, //是否显示工具栏
          orient: "horizontal", //工具栏icon的布局朝向‘horizontal’'vertical'
          itemSize: 15, //工具栏icon的大小
          itemGap: 10, //工具栏icon每项之间的间隔
          showTitle: false, //是否在鼠标hover的时候显示每个工具的icon标题
          feature: {
            dataView: {
              show: true,
              readOnly: false,
              lang: ["数据视图", "关闭"], // 这里将刷新改成其他用途
              readOnly: true,
              optionToContent(opt) {
                // console.log(opt);
                // return
                const series = opt.series[0].data; // 折线图数据
                const axisData = opt.yAxis[0].data; // 这里看你放的是x轴还是y轴
                let tdHeads =
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">案由类型</td>' +
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">数量</td>'; // 表头
                let tdBodys = ""; // 数据
                // series.forEach(function (item) {
                //   // 组装表头
                //   tdHeads +=
                //     '<td style="padding: 0 10px">' + item.name + "</td>";
                // });
                let table =
                  '<table id="exportTab" border="1" style="margin-left:20px;border-collapse:collapse;font-size:14px;text-align:center;margin: auto;width: 80%;"><tbody><tr style:"border-bottom: 1px solid #ebeef5;">' +
                  tdHeads +
                  " </tr>";
                for (let i = 0, l = axisData.length; i < l; i++) {
                  // for (let j = 0; j < series.length; j++) {
                  // 组装表数据
                  tdBodys +=
                    "<td  style='width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;'>" +
                    series[i] +
                    " 篇 </td>";
                  // }
                  table +=
                    '<tr><td style="width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;">' +
                    axisData[i] +
                    "</td>" +
                    tdBodys +
                    "</tr>";
                  tdBodys = "";
                }
                table += "</tbody></table>";
                return table;
              },
              // 重置刷新事件方法
              contentToOption(opt) {
                that.myBriefs();
              },
            },
            saveAsImage: {},
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },

        grid: {
          left: "15%",
          // bottom:"35%"
        },
        xAxis: {
          type: "value",

          boundaryGap: [0, 0.01],
        },
        yAxis: {
          show: true,
          boundaryGap: true,
          type: "category",
          data: this.trialKey_brief,
        },
        series: [
          {
            type: "bar",
            data: this.trialCount_brief,
            showBackground: true,
            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.2)",
            },
            // barWidth: 30, // 柱图宽度
            barMaxWidth: 30, // 最大宽度
            label: {
              //设置柱状图上显示  对应值
              show: true,
              position: "right",
              color: "#606266",
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  // 设置前三个颜色不一样
                  var num = params.value;
                  var djg = params.dataIndex; //第几个数
                  var retcoler = "#345edc";
                  if (djg > 9) {
                    retcoler = "#ef6b59";
                  }
                  return retcoler;
                },
                // barBorderRadius: [0, 8, 8, 0], // 设置柱状图圆角（顺时针左上，右上，右下，左下）
              },
            },
          },
        ],
      };
      myBrief.setOption(option, true);
      myBrief.on("click", (params) => {
        // console.log("a");
        return;
        let msg = {
          type: "brief",
          name: params.data.name,
          val: params.data.val,
          value: params.data.value,
        };
        this.$emit("transfer", msg);

        if (params.componentType === "series") {
          console.log("您点击了我");
        }
      });
      this.loading_3 = false;
    },
    myRadars() {
      // if (this.dataList.length <= 0) {
      //   window.document.getElementById("radar").style.height = "0px";
      // }
      var myRadar = this.$echarts.init(window.document.getElementById("radar"));
      var option = {
        title: {
          // text: 'Basic Radar Chart'
        },
        legend: {
          data: ["标的额"],
          x: "center",
          y: "bottom",
        },
        radar: {
          // shape: 'circle',
          indicator: [
            { name: "0-10万", max: 100000 },
            { name: "10-50万", max: 16000 },
            { name: "50-100万", max: 30000 },
            { name: "100-500万", max: 38000 },
            { name: "500-1000万", max: 52000 },
            { name: "1000-5000万", max: 25000 },
            { name: "5000万以上", max: 25000 },
          ],
        },
        tooltip: {
          trigger: "item",
        },
        series: [
          {
            // name: "Budget vs spending",
            type: "radar",

            // areaStyle: {},
            data: [
              {
                value: [4200, 3000, 20000, 35000, 50000, 18000, 18000],
                name: "标的额",
              },
            ],
          },
        ],
      };
      myRadar.setOption(option, true);
    },

    //点击保存下载图片
    downloadFile() {
      let aLink = document.createElement("a");
      let blob = this.base64ToBlob();
      let evt = document.createEvent("HTMLEvents");
      evt.initEvent("click", true, true);
      aLink.download = "积分趋势效果统计图"; //下载图片的名称
      aLink.href = URL.createObjectURL(blob);
      aLink.click();
    },
    exportImg() {
      //echart返回一个 base64 的 URL
      let myChart = this.$echarts.init(document.getElementById("paperworkPie"));
      return myChart.getDataURL({
        type: "png",
        pixelRatio: 1,
        backgroundColor: "#fff",
      });
    },
    base64ToBlob() {
      //将base64转换blob
      let img = this.exportImg();
      let parts = img.split(";base64,");
      let contentType = parts[0].split(":")[1];
      let raw = window.atob(parts[1]);
      let rawLength = raw.length;
      let uInt8Array = new Uint8Array(rawLength);
      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }
      return new Blob([uInt8Array], { type: contentType });
    },
    shenli() {
      this.shenliShow = !this.shenliShow;
    },
    reloadCharts() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },

    regional_map() {
      if (this.dataList.length <= 0) {
        window.document.getElementById("china_map").style.height = "0px";
      }
      this.loading_5 = false;
      var myRadar_map = this.$echarts.init(
        window.document.getElementById("china_map")
      );
      var option = {
        tooltip: {
          trigger: "item",
          // triggerOn: "click",
          // position: ["10%", "80%"],
          confine: true,
          // formatter: function (params) {
          //   var info =
          //     "<div style='position:relative;'>" +
          //     params.name + ": "+params.value+
          //     "</div>";
          //   return info;
          // },
          // padding: 1,
          // backgroundColor: "#e5e5e5", //提示标签背景颜色
        },

        toolbox: {
          show: true, //是否显示工具栏
          orient: "horizontal", //工具栏icon的布局朝向‘horizontal’'vertical'
          itemSize: 15, //工具栏icon的大小
          itemGap: 10, //工具栏icon每项之间的间隔
          showTitle: false, //是否在鼠标hover的时候显示每个工具的icon标题
          feature: {
            dataView: {
              show: true,
              readOnly: false,
              lang: ["数据视图", "关闭"], // 这里将刷新改成其他用途
              readOnly: true,
              optionToContent(opt) {
                // console.log(opt);
                // return
                // const series = opt.series[0].data; // 折线图数据
                const axisData = opt.series[0].data; // 这里看你放的是x轴还是y轴
                let tdHeads =
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">地区</td>' +
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">数量</td>'; // 表头
                let tdBodys = ""; // 数据
                // series.forEach(function (item) {
                //   // 组装表头
                //   tdHeads +=
                //     '<td style="padding: 0 10px">' + item.name + "</td>";
                // });
                let table =
                  '<table id="exportTab" border="1" style="margin-left:20px;border-collapse:collapse;font-size:14px;text-align:center;margin: auto;width: 80%;"><tbody><tr style:"border-bottom: 1px solid #ebeef5;">' +
                  tdHeads +
                  " </tr>";
                for (let i = 0, l = axisData.length; i < l; i++) {
                  // for (let j = 0; j < series.length; j++) {
                  // 组装表数据
                  tdBodys +=
                    "<td  style='width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;'>" +
                    axisData[i].value +
                    " 篇 </td>";
                  // }
                  table +=
                    '<tr><td style="width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;">' +
                    axisData[i].name +
                    "</td>" +
                    tdBodys +
                    "</tr>";
                  tdBodys = "";
                }
                table += "</tbody></table>";
                return table;
              },
              // 重置刷新事件方法
              contentToOption(opt) {
                that.regional_map();
              },
            },
            saveAsImage: {},
            myTool1: {
              show: false,
            },
          },
        },
        visualMap: {
          //地图图例
          show: true,
          left: 26,
          bottom: 40,
          showLabel: true,
          pieces: [
            //根据数据大小，各省显示不同颜色
            {
              gte: 100000,
              label: ">= 100000",
              color: "#1f307b",
            },
            {
              gte: 50000,
              lt: 99900,
              label: "50000 - 99900",
              color: "#3c57ce",
            },
            {
              gte: 10000,
              lt: 49900,
              label: "10000 - 49900",
              color: "#6f83db",
            },
            {
              gte: 1000,
              lt: 9900,
              label: "1000 - 9900",
              color: "#9face7",
            },
            {
              lt: 1000,
              label: "<1000",
              color: "#bcc5ee",
            },
          ],
        },

        geo: {
          //中国地图设置
          map: "china",
          scaleLimit: {
            min: 1,
            max: 2,
          },
          zoom: 1,
          // top: 120,
          label: {
            normal: {
              show: true,
              fontSize: "14",
              color: "rgba(0,0,0,0.7)",
            },
          },
          roam: true,
          itemStyle: {
            normal: {
              borderColor: "rgba(0, 0, 0, 0.2)",
            },
            emphasis: {
              areaColor: "#f2d5ad",
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              borderWidth: 0,
            },
          },
        },
        series: [
          {
            name: "地域",
            type: "map",
            geoIndex: 0,
            data: this.dataList,
          },
        ],
        visualMap: {
          min: 0,
          max: 10000000,
          // splitNumber: 10,
          inverse: false,
          orient: "horizontal",
          align: "auto",
          realtime: false,
          calculable: true,
          precision: 0,
          left: "center",
          itemHeight: 300,
          // text:['10000000 篇', '0篇'],
          inRange: {
            color: ["#7bb5e4", "#3463bb", "#0b3068"],
          }, //设置颜色
        },
      };
      myRadar_map.setOption(option, true);

      myRadar_map.on("click", (param) => {
        // console.log(param);
        this.regional_count = param.value;
        const provinceIndex = provincesText.findIndex((x) => {
          return param.name === x;
        });
        if (provinceIndex === -1) return;
        const provinceAlphabet = provinces[provinceIndex];
        // console.log(provinceAlphabet);
        this.getProvinceMapOpt(provinceAlphabet);
      });
    },
    getProvinceMapOpt(provinceAlphabet) {
      axios.get("province/" + provinceAlphabet + ".json").then((s) => {
        // console.log(s);
        // this.dataList = s.data.features;
        // this.regional_map();
        // return
        echarts.registerMap(provinceAlphabet, s.data);
        const option = this.getMapOpt(provinceAlphabet);
        var myRadar_map0 = this.$echarts.init(
          window.document.getElementById("china_map")
        );
        myRadar_map0.setOption(option, true);
      });
    },
    getMapOpt(place) {
      // console.log("a");
      const provinceIndex0 = provinces.findIndex((x) => {
        return place === x;
      });
      if (provinceIndex0 === -1) return;
      const provinceAlphabet0 = provincesText[provinceIndex0];
      const option = {
        // backgroundColor: "#F3F3F3", //地图背景颜色
        //以下是地图标题，我在此处设空，需要的可以自己加上
        title: {
          text: provinceAlphabet0 + " -- " + this.regional_count + "篇",
          subtext: "",
          left: "center",
        },
        //以下是地图右侧“还原”“下载”工具框
        toolbox: {
          show: true, //是否显示工具栏
          orient: "horizontal", //工具栏icon的布局朝向‘horizontal’'vertical'
          itemSize: 15, //工具栏icon的大小
          itemGap: 10, //工具栏icon每项之间的间隔
          showTitle: false, //是否在鼠标hover的时候显示每个工具的icon标题
          feature: {
            myTool1: {
              show: true,
              title: "还原",
              icon: "path://M512 981.333333c-209.866667 0-396.693333-126.026667-466.293333-314.08a35.52 35.52 0 0 1 23.626666-44.426666 38.613333 38.613333 0 0 1 48 20.693333c58.666667 158.933333 217.013333 265.493333 394.666667 265.6s336-106.666667 394.666667-266.133333a37.6 37.6 0 0 1 28.853333-23.626667 38.986667 38.986667 0 0 1 35.786667 11.946667 34.773333 34.773333 0 0 1 7.146666 35.36c-69.386667 188.373333-256.48 314.666667-466.453333 314.666666z m431.36-574.08a37.92 37.92 0 0 1-35.946667-24.266666C849.386667 222.56 690.613333 114.88 512 114.72S174.72 222.346667 116.746667 382.773333A38.72 38.72 0 0 1 69.333333 403.733333a35.786667 35.786667 0 0 1-24.106666-44.373333C113.333333 169.866667 301.013333 42.666667 512 42.666667s398.666667 127.306667 467.146667 316.96a34.56 34.56 0 0 1-4.906667 32.64 38.933333 38.933333 0 0 1-30.88 14.986666z",
              onclick: () => {
                // return
                // console.log("a");
                this.regional_map();
              },
            },
            saveAsImage: {},
          },
        },
        geo: {
          map: place || "china",
          label: {
            emphasis: {
              show: false,
            },
            // 不需要显示地名可直接删除normal此项
            normal: {
              show: false, // 是否显示对应地名
              textStyle: {
                color: "rgba(0,0,0)",
              },
            },
          },
          roam: true,
          itemStyle: {
            normal: {
              areaColor: "#6FA7CE", //地图颜色
              borderColor: "#fff", //地图边线颜色
            },
            emphasis: {
              areaColor: "#B7DFED", //鼠标移入颜色
            },
          },
        },
      };
      return option;
    },

    // 审理法院
    myBriefs0() {
      if (this.trialKey_brief0.length <= 0) {
        window.document.getElementById("briefPie0").style.height = "0px";
      }
      var myBrief0 = this.$echarts.init(
        window.document.getElementById("briefPie0")
      );
      //配置图表
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        toolbox: {
          show: true, //是否显示工具栏
          orient: "horizontal", //工具栏icon的布局朝向‘horizontal’'vertical'
          itemSize: 15, //工具栏icon的大小
          itemGap: 10, //工具栏icon每项之间的间隔
          showTitle: false, //是否在鼠标hover的时候显示每个工具的icon标题
          feature: {
            dataView: {
              show: true,
              readOnly: false,
              lang: ["数据视图", "关闭"], // 这里将刷新改成其他用途
              readOnly: true,
              optionToContent(opt) {
                // console.log(opt);
                // return
                const series = opt.series[0].data; // 折线图数据
                const axisData = opt.yAxis[0].data; // 这里看你放的是x轴还是y轴
                let tdHeads =
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">审理法院</td>' +
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">数量</td>'; // 表头
                let tdBodys = ""; // 数据
                // series.forEach(function (item) {
                //   // 组装表头
                //   tdHeads +=
                //     '<td style="padding: 0 10px">' + item.name + "</td>";
                // });
                let table =
                  '<table id="exportTab" border="1" style="margin-left:20px;border-collapse:collapse;font-size:14px;text-align:center;margin: auto;width: 80%;"><tbody><tr style:"border-bottom: 1px solid #ebeef5;">' +
                  tdHeads +
                  " </tr>";
                for (let i = 0, l = axisData.length; i < l; i++) {
                  // for (let j = 0; j < series.length; j++) {
                  // 组装表数据
                  tdBodys +=
                    "<td  style='width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;'>" +
                    series[i] +
                    " 篇 </td>";
                  // }
                  table +=
                    '<tr><td style="width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;">' +
                    axisData[i] +
                    "</td>" +
                    tdBodys +
                    "</tr>";
                  tdBodys = "";
                }
                table += "</tbody></table>";
                return table;
              },
              // 重置刷新事件方法
              contentToOption(opt) {
                that.myPaperwork_case();
              },
            },
            saveAsImage: {},
          },
        },
        grid: {
          left: "15%",
          // bottom:"35%"
        },
        xAxis: {
          type: "value",

          boundaryGap: [0, 0.01],
        },
        yAxis: {
          show: true,
          boundaryGap: true,
          type: "category",
          data: this.trialKey_brief0,
          // axisLabel: { show: false },

          axisLabel: {
            show: true,
            interval: 0,
            textStyle: {
              fontSize: "12",
              letterSpacing: "2",
            },
            formatter: function (params) {
              var newParamsName = "";
              var paramsNameNumber = params.length;
              var provideNumber = 5; //一行显示几个字
              var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
              if (paramsNameNumber > provideNumber) {
                for (var p = 0; p < rowNumber; p++) {
                  var tempStr = "";
                  var start = p * provideNumber;
                  var end = start + provideNumber;
                  if (p == rowNumber - 1) {
                    tempStr = params.substring(start, paramsNameNumber);
                  } else {
                    tempStr = params.substring(start, end) + "\n";
                  }
                  newParamsName += tempStr;
                }
              } else {
                newParamsName = params;
              }
              return newParamsName;
            },
          },
          // y轴的颜色和宽度
          // axisLine: {
          //   lineStyle: {
          //     color: "#107D9F",
          //     width: 1, //这里是坐标轴的宽度,可以去掉
          //   },
          // },
        },
        series: [
          {
            type: "bar",
            data: this.trialCount_brief0,
            showBackground: true,
            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.2)",
            },
            // barWidth: 30, // 柱图宽度
            barMaxWidth: 30, // 最大宽度
            label: {
              //设置柱状图上显示  对应值
              show: true,
              position: "right",
              color: "#606266",
              // color: "#ddb361",
              // show: true,
              // formatter: "{b}   ( {c} 篇)",
              // position: "left",
              // align: "left",
              // offset: [10, 2],
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  // 设置前三个颜色不一样
                  var num = params.value;
                  var djg = params.dataIndex; //第几个数
                  var retcoler = "#345edc";
                  if (djg > 9) {
                    retcoler = "#ef6b59";
                  }
                  return retcoler;
                },
                // barBorderRadius: [0, 8, 8, 0], // 设置柱状图圆角（顺时针左上，右上，右下，左下）
              },
            },
          },
        ],
      };
      myBrief0.setOption(option, true);
      this.loading_6 = false;
    },

    // 审理法官
    myBriefsJudge() {
      if (this.judge_Key.length <= 0) {
        window.document.getElementById("briefPie_judge").style.height = "0px";
      }
      var briefPie_judge = this.$echarts.init(
        window.document.getElementById("briefPie_judge")
      );
      //配置图表
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        toolbox: {
          show: true, //是否显示工具栏
          orient: "horizontal", //工具栏icon的布局朝向‘horizontal’'vertical'
          itemSize: 15, //工具栏icon的大小
          itemGap: 10, //工具栏icon每项之间的间隔
          showTitle: false, //是否在鼠标hover的时候显示每个工具的icon标题
          feature: {
            dataView: {
              show: true,
              readOnly: false,
              lang: ["数据视图", "关闭"], // 这里将刷新改成其他用途
              readOnly: true,
              optionToContent(opt) {
                // console.log(opt);
                // return
                const series = opt.series[0].data; // 折线图数据
                const axisData = opt.yAxis[0].data; // 这里看你放的是x轴还是y轴
                let tdHeads =
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">审理法官</td>' +
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">数量</td>'; // 表头
                let tdBodys = ""; // 数据
                // series.forEach(function (item) {
                //   // 组装表头
                //   tdHeads +=
                //     '<td style="padding: 0 10px">' + item.name + "</td>";
                // });
                let table =
                  '<table id="exportTab" border="1" style="margin-left:20px;border-collapse:collapse;font-size:14px;text-align:center;margin: auto;width: 80%;"><tbody><tr style:"border-bottom: 1px solid #ebeef5;">' +
                  tdHeads +
                  " </tr>";
                for (let i = 0, l = axisData.length; i < l; i++) {
                  // for (let j = 0; j < series.length; j++) {
                  // 组装表数据
                  tdBodys +=
                    "<td  style='width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;'>" +
                    series[i] +
                    "  </td>";
                  // }
                  table +=
                    '<tr><td style="width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;">' +
                    axisData[i] +
                    "</td>" +
                    tdBodys +
                    "</tr>";
                  tdBodys = "";
                }
                table += "</tbody></table>";
                return table;
              },
              // 重置刷新事件方法
              contentToOption(opt) {
                that.myBriefsJudge();
              },
            },
            saveAsImage: {},
          },
        },
        grid: {
          left: "15%",
          // bottom:"35%"
        },
        xAxis: {
          type: "value",

          boundaryGap: [0, 0.01],
        },
        yAxis: {
          show: true,
          boundaryGap: true,
          type: "category",
          data: this.judge_Key,
          // axisLabel: { show: false },

          axisLabel: {
            show: true,
            interval: 0,
            textStyle: {
              fontSize: "12",
              letterSpacing: "2",
            },
            formatter: function (params) {
              var newParamsName = "";
              var paramsNameNumber = params.length;
              var provideNumber = 5; //一行显示几个字
              var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
              if (paramsNameNumber > provideNumber) {
                for (var p = 0; p < rowNumber; p++) {
                  var tempStr = "";
                  var start = p * provideNumber;
                  var end = start + provideNumber;
                  if (p == rowNumber - 1) {
                    tempStr = params.substring(start, paramsNameNumber);
                  } else {
                    tempStr = params.substring(start, end) + "\n";
                  }
                  newParamsName += tempStr;
                }
              } else {
                newParamsName = params;
              }
              return newParamsName;
            },
          },
          // y轴的颜色和宽度
          // axisLine: {
          //   lineStyle: {
          //     color: "#107D9F",
          //     width: 1, //这里是坐标轴的宽度,可以去掉
          //   },
          // },
        },
        series: [
          {
            type: "bar",
            data: this.judge_Count,
            showBackground: true,
            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.2)",
            },
            // barWidth: 30, // 柱图宽度
            barMaxWidth: 30, // 最大宽度
            label: {
              //设置柱状图上显示  对应值
              show: true,
              position: "right",
              color: "#606266",
              // color: "#ddb361",
              // show: true,
              // formatter: "{b}   ( {c} 篇)",
              // position: "left",
              // align: "left",
              // offset: [10, 2],
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  // 设置前三个颜色不一样
                  var num = params.value;
                  var djg = params.dataIndex; //第几个数
                  var retcoler = "#345edc";
                  if (djg > 9) {
                    retcoler = "#ef6b59";
                  }
                  return retcoler;
                },
                // barBorderRadius: [0, 8, 8, 0], // 设置柱状图圆角（顺时针左上，右上，右下，左下）
              },
            },
          },
        ],
      };
      briefPie_judge.setOption(option, true);
      this.loading_9 = false;
    },

    // 诉讼费用
    fees_Chart() {
      if (this.fees_key.length <= 0) {
        window.document.getElementById("main_fees").style.height = "0px";
      }
      var main_feesChart = this.$echarts.init(
        window.document.getElementById("main_fees")
      );
      //配置图表
      var option = {
        toolbox: {
          show: true, //是否显示工具栏
          orient: "horizontal", //工具栏icon的布局朝向‘horizontal’'vertical'
          itemSize: 15, //工具栏icon的大小
          itemGap: 10, //工具栏icon每项之间的间隔
          showTitle: false, //是否在鼠标hover的时候显示每个工具的icon标题
          feature: {
            dataView: {
              show: true,
              readOnly: false,
              lang: ["数据视图", "关闭"], // 这里将刷新改成其他用途
              readOnly: true,
              optionToContent(opt) {
                // console.log(opt);
                // return
                const series = opt.series[0].data; // 折线图数据
                const axisData = opt.xAxis[0].data; // 这里看你放的是x轴还是y轴
                let tdHeads =
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">诉讼费用</td>' +
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">数量</td>'; // 表头
                let tdBodys = ""; // 数据
                // series.forEach(function (item) {
                //   // 组装表头
                //   tdHeads +=
                //     '<td style="padding: 0 10px">' + item.name + "</td>";
                // });
                let table =
                  '<table id="exportTab" border="1" style="margin-left:20px;border-collapse:collapse;font-size:14px;text-align:center;margin: auto;width: 80%;"><tbody><tr style:"border-bottom: 1px solid #ebeef5;">' +
                  tdHeads +
                  " </tr>";
                for (let i = 0, l = axisData.length; i < l; i++) {
                  // for (let j = 0; j < series.length; j++) {
                  // 组装表数据
                  tdBodys +=
                    "<td  style='width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;'>" +
                    series[i] +
                    " </td>";
                  // }
                  table +=
                    '<tr><td style="width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;">' +
                    axisData[i] +
                    "</td>" +
                    tdBodys +
                    "</tr>";
                  tdBodys = "";
                }
                table += "</tbody></table>";
                return table;
              },
              // 重置刷新事件方法
              contentToOption(opt) {
                that.fees_Chart();
              },
            },
            saveAsImage: {},
          },
        },
        // dataZoom: [
        //   {
        //     type: "slider",
        //     show: true,
        //     // xAxisIndex: [0],
        //     // left: "9%",
        //     // bottom: -5,
        //     start: 50,
        //     end: 100, //初始化滚动条
        //     ValueSpan: 20,
        //     // minValueSpan: 20, //用于限制窗口大小的最小值,在类目轴上可以设置为 5 表示 5 个类目
        //     // maxValueSpan: 20, //用于限制窗口大小的最小值,在类目轴上可以设置为 5 表示 5 个类目
        //     // zoomLock: false,
        //     filterMode: "empty", //增加这句属性设值
        //     zoomOnMouseWheel: true,
        //     borderColor: "#eee", //滑动通道的边框颜色

        //     fillerColor: "#ddb361", //滑动条颜色
        //     backgroundColor: "#eee", //未选中的滑动条的颜色
        //     showDataShadow: false, //是否显示数据阴影 默认auto
        //     height: 14,
        //   },
        // ],
        title: {
          text: "",
        },
        tooltip: {},
        legend: {
          data: [""],
        },
        xAxis: {
          data: this.fees_key,
        },
        grid: {
          left: "15%",
          // bottom:"35%"
        },
        yAxis: {},
        series: [
          {
            name: "",
            type: "line",
            avoidLabelOverlap: true, //对，就是这里avoidLabelOverlap
            itemStyle: {
              normal: {
                color: "#f99362", //改变折线点的颜色
                lineStyle: {
                  color: "#f99362", //改变折线颜色
                },
              },
            },
            data: this.fees_count,
            // showBackground: true,
            // backgroundStyle: {
            //   color: "rgba(180, 180, 180, 0.2)",
            // },
          },
        ],
      };
      main_feesChart.setOption(option, true);
      this.loading_8 = false;

      main_feesChart.on("click", (params) => {
        console.log(params);
        let msg = {
          type: "fee",
          name: params.name,
          // val:params
        };
        // let name = params.name.replace(/\元/g, ''); // \:转义符
        // if (params.name.includes("-")){
        //    name = name.split('-');
        // console.log(name)
        // msg.name.start = name[0];
        // msg.name.end = name[1];
        // }else if(params.name == "<50"){
        //   msg.name.start = 0;
        // msg.name.end = 50;
        // }else if(params.name == ">10000"){
        //   msg.name.start = 10000;
        // msg.name.end = 0;
        // }

        // return

        this.$emit("transfer", msg);
        return;
        if (params.componentType === "series") {
          console.log("您点击了我");
        }
      });
    },

    data_dispose() {
      this.timeLine = this.dataCharts.Time;
      this.trialBar = this.dataCharts.TrialPro;
      // console.log(this.timeLine)
      this.timeYears = [];
      this.timeCount = [];
      this.shenliPie = [];
      this.paperKey = [];
      this.paperContent = [];
      this.level = [];
      this.timeLine.reverse().forEach((item) => {
        this.timeYears.push(item.key_as_string);
        this.timeCount.push(item.doc_count);
      });
      this.trialCount = [];
      this.trialKey = [];

      // this.paperCharts_program = [];
      // console.log(this.trialBar);
      this.trialBar.forEach((item) => {
        this.trialCount.push(item.doc_count);
        this.trialKey.push(item.key);
        let shen = {
          value: item.doc_count,
          name: item.key,
        };
        this.shenliPie.push(shen);
      });
      this.paperCharts = [];
      this.dataCharts.DocType.forEach((item) => {
        this.paperKey.push(item.key);
        this.paperContent.push(item.doc_count);
        let paper = {
          value: item.doc_count,
          name: item.key,
        };
        this.paperCharts.push(paper);
      });
      // console.log(this.dataCharts.reason)
      this.paperCharts_case = [];
      this.dataCharts.reason.forEach((item) => {
        let paper_case = {
          value: item.count,
          name: item.name,
          val: item.val,
        };
        this.paperCharts_case.push(paper_case);
      });

      this.trialCount_brief = [];
      this.trialKey_brief = [];
      this.dataCharts.reason.forEach((item) => {
        this.trialCount_brief.push(item.count);
        this.trialKey_brief.push(item.name);
        let cause = {
          value: item.count,
          name: item.name,
        };
        this.briefChart.push(cause);
      });
      this.dataCharts.Leval.forEach((item) => {
        let rank = {
          value: item.doc_count,
          name: item.key,
        };
        this.level.push(rank);
      });

      this.trialCount_brief0 = [];
      this.trialKey_brief0 = [];
      this.dataCharts.court.forEach((item) => {
        this.trialCount_brief0.push(item.children[0].count);
        this.trialKey_brief0.push(item.children[0].name);
      });
      if (this.dataCharts.court.length > 5) {
        this.trialCount_brief0 = this.trialCount_brief0.slice(0, 5);
        this.trialKey_brief0 = this.trialKey_brief0.slice(0, 5);
      }
      this.refer_level = [];
      this.dataCharts.Ref_level.forEach((item) => {
        let refer = {
          value: item.doc_count,
          name: item.key,
        };
        this.refer_level.push(refer);
      });
      this.dataList = this.dataCharts.court;
      this.dataList.forEach((item, index) => {
        this.dataList[index].value = this.dataList[index].count;
      });
    },
    data_dispose0() {
      return;
      this.myEcharts();
      this.myTrials();
      // this.myshenli();
      this.myPaperwork();
      this.myPaperwork_case();
      this.myBriefs();
      this.myLevel();

      this.regional_map();
      // this.myBriefs0();
      this.loading = false;
    },

    // 法条引用
    Briefs_laws() {
      if (this.laws_key.length <= 0) {
        window.document.getElementById("briefPie_laws").style.height = "0px";
      } else if (this.laws_key.length > 0 && this.laws_key.length <= 5) {
        window.document.getElementById("briefPie_laws").style.height = "350px";
      } else if (this.laws_key.length > 5 && this.laws_key.length < 10) {
        window.document.getElementById("briefPie_laws").style.height = "600px";
      }
      // else{
      //   let he = (this.laws_key.length * 70).toString();
      //   console.log(this.laws_key)
      //  he= he+"px"
      //   window.document.getElementById("briefPie_laws").style.height = he;
      // }
      var briefPie_laws = this.$echarts.init(
        window.document.getElementById("briefPie_laws")
      );
      //配置图表
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        toolbox: {
          show: true, //是否显示工具栏
          orient: "horizontal", //工具栏icon的布局朝向‘horizontal’'vertical'
          itemSize: 15, //工具栏icon的大小
          itemGap: 10, //工具栏icon每项之间的间隔
          showTitle: false, //是否在鼠标hover的时候显示每个工具的icon标题
          feature: {
            dataView: {
              show: true,
              readOnly: false,
              lang: ["数据视图", "关闭"], // 这里将刷新改成其他用途
              readOnly: true,
              optionToContent(opt) {
                // console.log(opt);
                // return
                const series = opt.series[0].data; // 折线图数据
                const axisData = opt.yAxis[0].data; // 这里看你放的是x轴还是y轴
                let tdHeads =
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">引用法条</td>' +
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">数量</td>'; // 表头
                let tdBodys = ""; // 数据
                // series.forEach(function (item) {
                //   // 组装表头
                //   tdHeads +=
                //     '<td style="padding: 0 10px">' + item.name + "</td>";
                // });
                let table =
                  '<table id="exportTab" border="1" style="margin-left:20px;border-collapse:collapse;font-size:14px;text-align:center;margin: auto;width: 80%;"><tbody><tr style:"border-bottom: 1px solid #ebeef5;">' +
                  tdHeads +
                  " </tr>";
                for (let i = 0, l = axisData.length; i < l; i++) {
                  // for (let j = 0; j < series.length; j++) {
                  // 组装表数据
                  tdBodys +=
                    "<td  style='width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;'>" +
                    series[i] +
                    "  </td>";
                  // }
                  table +=
                    '<tr><td style="width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;">' +
                    axisData[i] +
                    "</td>" +
                    tdBodys +
                    "</tr>";
                  tdBodys = "";
                }
                table += "</tbody></table>";
                return table;
              },
              // 重置刷新事件方法
              contentToOption(opt) {
                that.Briefs_laws();
              },
            },
            saveAsImage: {},
          },
        },
        grid: {
          left: "20%",
          // bottom:"35%"
        },
        xAxis: {
          type: "value",

          boundaryGap: [0, 0.01],
        },
        yAxis: {
          show: true,
          containLabel: true,
          boundaryGap: true,
          type: "category",
          data: this.laws_key,
          // axisLabel: { show: false },

          axisLabel: {
            show: true,
            interval: 0,
            textStyle: {
              fontSize: "12",
              letterSpacing: "2",
            },
            formatter: function (params) {
              var newParamsName = "";
              var paramsNameNumber = params.length;
              var provideNumber = 16; //一行显示几个字
              var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
              if (paramsNameNumber > provideNumber) {
                for (var p = 0; p < rowNumber; p++) {
                  var tempStr = "";
                  var start = p * provideNumber;
                  var end = start + provideNumber;
                  if (p == rowNumber - 1) {
                    tempStr = params.substring(start, paramsNameNumber);
                  } else {
                    tempStr = params.substring(start, end) + "\n";
                  }
                  newParamsName += tempStr;
                }
              } else {
                newParamsName = params;
              }
              return newParamsName;
            },
          },
          // y轴的颜色和宽度
          // axisLine: {
          //   lineStyle: {
          //     color: "#107D9F",
          //     width: 1, //这里是坐标轴的宽度,可以去掉
          //   },
          // },
        },
        series: [
          {
            type: "bar",
            data: this.laws_count,
            showBackground: true,
            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.2)",
            },
            // barWidth: 30, // 柱图宽度
            barMaxWidth: 40, // 最大宽度
            label: {
              //设置柱状图上显示  对应值
              show: true,
              position: "right",
              color: "#606266",
              // color: "#ddb361",
              // show: true,
              // formatter: "{b}   ( {c} 篇)",
              // position: "left",
              // align: "left",
              // offset: [10, 2],
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  // 设置前三个颜色不一样
                  var num = params.value;
                  var djg = params.dataIndex; //第几个数
                  var retcoler = "#345edc";
                  if (djg > 9) {
                    retcoler = "#ef6b59";
                  }
                  return retcoler;
                },
                // barBorderRadius: [0, 8, 8, 0], // 设置柱状图圆角（顺时针左上，右上，右下，左下）
              },
            },
          },
        ],
      };
      briefPie_laws.setOption(option, true);
      this.loading_20 = false;
    },

    // 案件终审情况
    Paperwork_Final() {
      if (this.paperCharts_Final.length <= 0) {
        window.document.getElementById("paperworkPie_Final").style.height =
          "0px";
      }
      var myPaper_Final = this.$echarts.init(
        window.document.getElementById("paperworkPie_Final")
      );
      var option = {
        toolbox: {
          show: true, //是否显示工具栏
          orient: "horizontal", //工具栏icon的布局朝向‘horizontal’'vertical'
          itemSize: 15, //工具栏icon的大小
          itemGap: 10, //工具栏icon每项之间的间隔
          showTitle: false, //是否在鼠标hover的时候显示每个工具的icon标题
          feature: {
            dataView: {
              show: true,
              readOnly: false,
              lang: ["数据视图", "关闭"], // 这里将刷新改成其他用途
              readOnly: true,
              optionToContent(opt) {
                // console.log(opt);
                // return
                // const series = opt.series[0].data; // 折线图数据
                const axisData = opt.series[0].data; // 这里看你放的是x轴还是y轴
                let tdHeads =
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">终审情况</td>' +
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">数量</td>'; // 表头
                let tdBodys = ""; // 数据
                // series.forEach(function (item) {
                //   // 组装表头
                //   tdHeads +=
                //     '<td style="padding: 0 10px">' + item.name + "</td>";
                // });
                let table =
                  '<table id="exportTab" border="1" style="margin-left:20px;border-collapse:collapse;font-size:14px;text-align:center;margin: auto;width: 80%;"><tbody><tr style:"border-bottom: 1px solid #ebeef5;">' +
                  tdHeads +
                  " </tr>";
                for (let i = 0, l = axisData.length; i < l; i++) {
                  // for (let j = 0; j < series.length; j++) {
                  // 组装表数据
                  tdBodys +=
                    "<td  style='width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;'>" +
                    axisData[i].value +
                    " 篇 </td>";
                  // }
                  table +=
                    '<tr><td style="width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;">' +
                    axisData[i].name +
                    "</td>" +
                    tdBodys +
                    "</tr>";
                  tdBodys = "";
                }
                table += "</tbody></table>";
                return table;
              },
              // 重置刷新事件方法
              contentToOption(opt) {
                that.Paperwork_Final();
              },
            },
            saveAsImage: {},
          },
        },
        title: {
          //   text: "Referer of a Website",
          //   subtext: "Fake Data",
          //   left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          // orient: "vertical",
          // left: "right",
          x: "center",
          y: "bottom",
        },
        series: [
          {
            // name: "Access From",
            type: "pie",
            radius: ["40%", "70%"],
            label: {
              normal: {
                // show: true,
                // position: 'inside',
                formatter: "{b}({d}%)", //模板变量有 {a}、{b}、{c}、{d}，分别表示系列名，数据名，数据值，百分比。{d}数据会根据value值计算百分比
              },
            },
            data: this.paperCharts_Final,
            // emphasis: {
            //   itemStyle: {
            //     shadowBlur: 10,
            //     shadowOffsetX: 0,
            //     shadowColor: "rgba(0, 0, 0, 0.5)",
            //   },
            // },
          },
        ],
      };
      myPaper_Final.setOption(option, true);
      this.loading_21 = false;
    },

    // 案件周期情况
    myEcharts_cycle() {
      if (this.cycle_key.length <= 0) {
        window.document.getElementById("main_cycle").style.height = "0px";
      }
      var Chart_cycle = this.$echarts.init(
        window.document.getElementById("main_cycle")
      );
      //配置图表
      var option = {
        toolbox: {
          show: true, //是否显示工具栏
          orient: "horizontal", //工具栏icon的布局朝向‘horizontal’'vertical'
          itemSize: 15, //工具栏icon的大小
          itemGap: 10, //工具栏icon每项之间的间隔
          showTitle: false, //是否在鼠标hover的时候显示每个工具的icon标题
          feature: {
            dataView: {
              show: true,
              readOnly: false,
              lang: ["数据视图", "关闭"], // 这里将刷新改成其他用途
              readOnly: true,
              optionToContent(opt) {
                // console.log(opt);
                // return
                const series = opt.series[0].data; // 折线图数据
                const axisData = opt.xAxis[0].data; // 这里看你放的是x轴还是y轴
                let tdHeads =
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">案件周期</td>' +
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">数量</td>'; // 表头
                let tdBodys = ""; // 数据
                // series.forEach(function (item) {
                //   // 组装表头
                //   tdHeads +=
                //     '<td style="padding: 0 10px">' + item.name + "</td>";
                // });
                let table =
                  '<table id="exportTab" border="1" style="margin-left:20px;border-collapse:collapse;font-size:14px;text-align:center;margin: auto;width: 80%;"><tbody><tr style:"border-bottom: 1px solid #ebeef5;">' +
                  tdHeads +
                  " </tr>";
                for (let i = 0, l = axisData.length; i < l; i++) {
                  // for (let j = 0; j < series.length; j++) {
                  // 组装表数据
                  tdBodys +=
                    "<td  style='width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;'>" +
                    series[i] +
                    " 篇 </td>";
                  // }
                  table +=
                    '<tr><td style="width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;">' +
                    axisData[i] +
                    "</td>" +
                    tdBodys +
                    "</tr>";
                  tdBodys = "";
                }
                table += "</tbody></table>";
                return table;
              },
              // 重置刷新事件方法
              contentToOption(opt) {
                that.myEcharts_cycle();
              },
            },
            saveAsImage: {},
          },
        },
        // dataZoom: [
        //   {
        //     type: "slider",
        //     show: true,
        //     // xAxisIndex: [0],
        //     // left: "9%",
        //     // bottom: -5,
        //     start: 50,
        //     end: 100, //初始化滚动条
        //     ValueSpan: 20,
        //     // minValueSpan: 20, //用于限制窗口大小的最小值,在类目轴上可以设置为 5 表示 5 个类目
        //     // maxValueSpan: 20, //用于限制窗口大小的最小值,在类目轴上可以设置为 5 表示 5 个类目
        //     // zoomLock: false,
        //     filterMode: "empty", //增加这句属性设值
        //     zoomOnMouseWheel: true,
        //     borderColor: "#eee", //滑动通道的边框颜色

        //     fillerColor: "#ddb361", //滑动条颜色
        //     backgroundColor: "#eee", //未选中的滑动条的颜色
        //     showDataShadow: false, //是否显示数据阴影 默认auto
        //     height: 14,
        //   },
        // ],
        title: {
          text: "",
        },
        tooltip: {},
        legend: {
          data: [""],
        },
        xAxis: {
          data: this.cycle_key,
        },
        grid: {
          left: "15%",
          // bottom:"35%"
        },
        yAxis: {},
        series: [
          {
            name: "时间",
            type: "line",
            avoidLabelOverlap: true, //对，就是这里avoidLabelOverlap
            itemStyle: {
              normal: {
                color: "#f99362", //改变折线点的颜色
                lineStyle: {
                  color: "#f99362", //改变折线颜色
                },
              },
            },
            data: this.cycle_count,
            // showBackground: true,
            // backgroundStyle: {
            //   color: "rgba(180, 180, 180, 0.2)",
            // },
          },
        ],
      };
      Chart_cycle.setOption(option, true);
      this.loading_22 = false;
    },

    // 原告类型
    Paperwork_type() {
      if (this.paperCharts_type.length <= 0) {
        window.document.getElementById("paperworkPie_type").style.height =
          "0px";
      }
      var myPaper_type = this.$echarts.init(
        window.document.getElementById("paperworkPie_type")
      );
      var option = {
        toolbox: {
          show: true, //是否显示工具栏
          orient: "horizontal", //工具栏icon的布局朝向‘horizontal’'vertical'
          itemSize: 15, //工具栏icon的大小
          itemGap: 10, //工具栏icon每项之间的间隔
          showTitle: false, //是否在鼠标hover的时候显示每个工具的icon标题
          feature: {
            dataView: {
              show: true,
              readOnly: false,
              lang: ["数据视图", "关闭"], // 这里将刷新改成其他用途
              readOnly: true,
              optionToContent(opt) {
                // console.log(opt);
                // return
                // const series = opt.series[0].data; // 折线图数据
                const axisData = opt.series[0].data; // 这里看你放的是x轴还是y轴
                let tdHeads =
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">原告类型</td>' +
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">数量</td>'; // 表头
                let tdBodys = ""; // 数据
                // series.forEach(function (item) {
                //   // 组装表头
                //   tdHeads +=
                //     '<td style="padding: 0 10px">' + item.name + "</td>";
                // });
                let table =
                  '<table id="exportTab" border="1" style="margin-left:20px;border-collapse:collapse;font-size:14px;text-align:center;margin: auto;width: 80%;"><tbody><tr style:"border-bottom: 1px solid #ebeef5;">' +
                  tdHeads +
                  " </tr>";
                for (let i = 0, l = axisData.length; i < l; i++) {
                  // for (let j = 0; j < series.length; j++) {
                  // 组装表数据
                  tdBodys +=
                    "<td  style='width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;'>" +
                    axisData[i].value +
                    " 篇 </td>";
                  // }
                  table +=
                    '<tr><td style="width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;">' +
                    axisData[i].name +
                    "</td>" +
                    tdBodys +
                    "</tr>";
                  tdBodys = "";
                }
                table += "</tbody></table>";
                return table;
              },
              // 重置刷新事件方法
              contentToOption(opt) {
                that.Paperwork_type();
              },
            },
            saveAsImage: {},
          },
        },
        title: {
          //   text: "Referer of a Website",
          //   subtext: "Fake Data",
          //   left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          // orient: "vertical",
          // left: "right",
          x: "center",
          y: "bottom",
        },
        series: [
          {
            // name: "Access From",
            type: "pie",
            radius: ["40%", "70%"],
            label: {
              normal: {
                // show: true,
                // position: 'inside',
                formatter: "{b}({d}%)", //模板变量有 {a}、{b}、{c}、{d}，分别表示系列名，数据名，数据值，百分比。{d}数据会根据value值计算百分比
              },
            },
            data: this.paperCharts_type,
            // emphasis: {
            //   itemStyle: {
            //     shadowBlur: 10,
            //     shadowOffsetX: 0,
            //     shadowColor: "rgba(0, 0, 0, 0.5)",
            //   },
            // },
          },
        ],
      };
      myPaper_type.setOption(option, true);
      this.loading_10 = false;
    },

    // 个人原告
    Briefs_individual() {
      if (this.individual_key.length <= 0) {
        window.document.getElementById("briefPie_individual").style.height =
          "0px";
      }
      var briefPie_individual = this.$echarts.init(
        window.document.getElementById("briefPie_individual")
      );
      //配置图表
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        toolbox: {
          show: true, //是否显示工具栏
          orient: "horizontal", //工具栏icon的布局朝向‘horizontal’'vertical'
          itemSize: 15, //工具栏icon的大小
          itemGap: 10, //工具栏icon每项之间的间隔
          showTitle: false, //是否在鼠标hover的时候显示每个工具的icon标题
          feature: {
            dataView: {
              show: true,
              readOnly: false,
              lang: ["数据视图", "关闭"], // 这里将刷新改成其他用途
              readOnly: true,
              optionToContent(opt) {
                // console.log(opt);
                // return
                const series = opt.series[0].data; // 折线图数据
                const axisData = opt.yAxis[0].data; // 这里看你放的是x轴还是y轴
                let tdHeads =
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">原告</td>' +
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">数量</td>'; // 表头
                let tdBodys = ""; // 数据
                // series.forEach(function (item) {
                //   // 组装表头
                //   tdHeads +=
                //     '<td style="padding: 0 10px">' + item.name + "</td>";
                // });
                let table =
                  '<table id="exportTab" border="1" style="margin-left:20px;border-collapse:collapse;font-size:14px;text-align:center;margin: auto;width: 80%;"><tbody><tr style:"border-bottom: 1px solid #ebeef5;">' +
                  tdHeads +
                  " </tr>";
                for (let i = 0, l = axisData.length; i < l; i++) {
                  // for (let j = 0; j < series.length; j++) {
                  // 组装表数据
                  tdBodys +=
                    "<td  style='width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;'>" +
                    series[i] +
                    "  </td>";
                  // }
                  table +=
                    '<tr><td style="width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;">' +
                    axisData[i] +
                    "</td>" +
                    tdBodys +
                    "</tr>";
                  tdBodys = "";
                }
                table += "</tbody></table>";
                return table;
              },
              // 重置刷新事件方法
              contentToOption(opt) {
                that.Briefs_individual();
              },
            },
            saveAsImage: {},
          },
        },
        grid: {
          // left: "20%",
          // bottom:"35%"
        },
        xAxis: {
          type: "value",

          boundaryGap: [0, 0.01],
        },
        yAxis: {
          show: true,
          containLabel: true,
          boundaryGap: true,
          type: "category",
          data: this.individual_key,
          // axisLabel: { show: false },

          axisLabel: {
            show: true,
            interval: 0,
            textStyle: {
              fontSize: "12",
              letterSpacing: "2",
            },
            formatter: function (params) {
              var newParamsName = "";
              var paramsNameNumber = params.length;
              var provideNumber = 10; //一行显示几个字
              var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
              if (paramsNameNumber > provideNumber) {
                for (var p = 0; p < rowNumber; p++) {
                  var tempStr = "";
                  var start = p * provideNumber;
                  var end = start + provideNumber;
                  if (p == rowNumber - 1) {
                    tempStr = params.substring(start, paramsNameNumber);
                  } else {
                    tempStr = params.substring(start, end) + "\n";
                  }
                  newParamsName += tempStr;
                }
              } else {
                newParamsName = params;
              }
              return newParamsName;
            },
          },
          // y轴的颜色和宽度
          // axisLine: {
          //   lineStyle: {
          //     color: "#107D9F",
          //     width: 1, //这里是坐标轴的宽度,可以去掉
          //   },
          // },
        },
        series: [
          {
            type: "bar",
            data: this.individual_count,
            showBackground: true,
            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.2)",
            },
            // barWidth: 30, // 柱图宽度
            barMaxWidth: 40, // 最大宽度
            label: {
              //设置柱状图上显示  对应值
              show: true,
              position: "right",
              color: "#606266",
              // color: "#ddb361",
              // show: true,
              // formatter: "{b}   ( {c} 篇)",
              // position: "left",
              // align: "left",
              // offset: [10, 2],
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  // 设置前三个颜色不一样
                  var num = params.value;
                  var djg = params.dataIndex; //第几个数
                  var retcoler = "#345edc";
                  if (djg > 9) {
                    retcoler = "#ef6b59";
                  }
                  return retcoler;
                },
                // barBorderRadius: [0, 8, 8, 0], // 设置柱状图圆角（顺时针左上，右上，右下，左下）
              },
            },
          },
        ],
      };
      briefPie_individual.setOption(option, true);
      this.loading_13 = false;
    },

    // 机构原告
    Briefs_institution() {
      // console.log(this.institution_key);
      if (this.institution_key.length <= 0) {
        window.document.getElementById("briefPie_institution").style.height =
          "0px";
      }
      var briefPie_institution = this.$echarts.init(
        window.document.getElementById("briefPie_institution")
      );
      //配置图表
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        toolbox: {
          show: true, //是否显示工具栏
          orient: "horizontal", //工具栏icon的布局朝向‘horizontal’'vertical'
          itemSize: 15, //工具栏icon的大小
          itemGap: 10, //工具栏icon每项之间的间隔
          showTitle: false, //是否在鼠标hover的时候显示每个工具的icon标题
          feature: {
            dataView: {
              show: true,
              readOnly: false,
              lang: ["数据视图", "关闭"], // 这里将刷新改成其他用途
              readOnly: true,
              optionToContent(opt) {
                // console.log(opt);
                // return
                const series = opt.series[0].data; // 折线图数据
                const axisData = opt.yAxis[0].data; // 这里看你放的是x轴还是y轴
                let tdHeads =
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">原告</td>' +
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">数量</td>'; // 表头
                let tdBodys = ""; // 数据
                // series.forEach(function (item) {
                //   // 组装表头
                //   tdHeads +=
                //     '<td style="padding: 0 10px">' + item.name + "</td>";
                // });
                let table =
                  '<table id="exportTab" border="1" style="margin-left:20px;border-collapse:collapse;font-size:14px;text-align:center;margin: auto;width: 80%;"><tbody><tr style:"border-bottom: 1px solid #ebeef5;">' +
                  tdHeads +
                  " </tr>";
                for (let i = 0, l = axisData.length; i < l; i++) {
                  // for (let j = 0; j < series.length; j++) {
                  // 组装表数据
                  tdBodys +=
                    "<td  style='width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;'>" +
                    series[i] +
                    "  </td>";
                  // }
                  table +=
                    '<tr><td style="width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;">' +
                    axisData[i] +
                    "</td>" +
                    tdBodys +
                    "</tr>";
                  tdBodys = "";
                }
                table += "</tbody></table>";
                return table;
              },
              // 重置刷新事件方法
              contentToOption(opt) {
                that.Briefs_institution();
              },
            },
            saveAsImage: {},
          },
        },
        grid: {
          left: "20%",
          // bottom:"35%"
        },
        xAxis: {
          type: "value",

          boundaryGap: [0, 0.01],
        },
        yAxis: {
          show: true,
          containLabel: true,
          boundaryGap: true,
          type: "category",
          data: this.institution_key,
          // axisLabel: { show: false },

          axisLabel: {
            show: true,
            interval: 0,
            textStyle: {
              fontSize: "12",
              letterSpacing: "2",
            },
            formatter: function (params) {
              var newParamsName = "";
              var paramsNameNumber = params.length;
              var provideNumber = 7; //一行显示几个字
              var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
              if (paramsNameNumber > provideNumber) {
                for (var p = 0; p < rowNumber; p++) {
                  var tempStr = "";
                  var start = p * provideNumber;
                  var end = start + provideNumber;
                  if (p == rowNumber - 1) {
                    tempStr = params.substring(start, paramsNameNumber);
                  } else {
                    tempStr = params.substring(start, end) + "\n";
                  }
                  newParamsName += tempStr;
                }
              } else {
                newParamsName = params;
              }
              return newParamsName;
            },
          },
          // y轴的颜色和宽度
          // axisLine: {
          //   lineStyle: {
          //     color: "#107D9F",
          //     width: 1, //这里是坐标轴的宽度,可以去掉
          //   },
          // },
        },
        series: [
          {
            type: "bar",
            data: this.institution_count,
            showBackground: true,
            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.2)",
            },
            // barWidth: 30, // 柱图宽度
            barMaxWidth: 40, // 最大宽度
            label: {
              //设置柱状图上显示  对应值
              show: true,
              position: "right",
              color: "#606266",
              // color: "#ddb361",
              // show: true,
              // formatter: "{b}   ( {c} 篇)",
              // position: "left",
              // align: "left",
              // offset: [10, 2],
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  // 设置前三个颜色不一样
                  var num = params.value;
                  var djg = params.dataIndex; //第几个数
                  var retcoler = "#345edc";
                  if (djg > 9) {
                    retcoler = "#ef6b59";
                  }
                  return retcoler;
                },
                // barBorderRadius: [0, 8, 8, 0], // 设置柱状图圆角（顺时针左上，右上，右下，左下）
              },
            },
          },
        ],
      };
      briefPie_institution.setOption(option, true);
      this.loading_14 = false;
    },

    // 律师
    Briefs_lawyer() {
      if (this.lawyer_key.length <= 0) {
        window.document.getElementById("briefPie_lawyer").style.height = "0px";
      }
      var briefPie_lawyer = this.$echarts.init(
        window.document.getElementById("briefPie_lawyer")
      );
      //配置图表
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        toolbox: {
          show: true, //是否显示工具栏
          orient: "horizontal", //工具栏icon的布局朝向‘horizontal’'vertical'
          itemSize: 15, //工具栏icon的大小
          itemGap: 10, //工具栏icon每项之间的间隔
          showTitle: false, //是否在鼠标hover的时候显示每个工具的icon标题
          feature: {
            dataView: {
              show: true,
              readOnly: false,
              lang: ["数据视图", "关闭"], // 这里将刷新改成其他用途
              readOnly: true,
              optionToContent(opt) {
                // console.log(opt);
                // return
                const series = opt.series[0].data; // 折线图数据
                const axisData = opt.yAxis[0].data; // 这里看你放的是x轴还是y轴
                let tdHeads =
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">律师</td>' +
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">数量</td>'; // 表头
                let tdBodys = ""; // 数据
                // series.forEach(function (item) {
                //   // 组装表头
                //   tdHeads +=
                //     '<td style="padding: 0 10px">' + item.name + "</td>";
                // });
                let table =
                  '<table id="exportTab" border="1" style="margin-left:20px;border-collapse:collapse;font-size:14px;text-align:center;margin: auto;width: 80%;"><tbody><tr style:"border-bottom: 1px solid #ebeef5;">' +
                  tdHeads +
                  " </tr>";
                for (let i = 0, l = axisData.length; i < l; i++) {
                  // for (let j = 0; j < series.length; j++) {
                  // 组装表数据
                  tdBodys +=
                    "<td  style='width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;'>" +
                    series[i] +
                    "  </td>";
                  // }
                  table +=
                    '<tr><td style="width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;">' +
                    axisData[i] +
                    "</td>" +
                    tdBodys +
                    "</tr>";
                  tdBodys = "";
                }
                table += "</tbody></table>";
                return table;
              },
              // 重置刷新事件方法
              contentToOption(opt) {
                that.Briefs_lawyer();
              },
            },
            saveAsImage: {},
          },
        },
        grid: {
          left: "20%",
          // bottom:"35%"
        },
        xAxis: {
          type: "value",

          boundaryGap: [0, 0.01],
        },
        yAxis: {
          show: true,
          containLabel: true,
          boundaryGap: true,
          type: "category",
          data: this.lawyer_key,
          // axisLabel: { show: false },

          axisLabel: {
            show: true,
            interval: 0,
            textStyle: {
              fontSize: "12",
              letterSpacing: "2",
            },
            formatter: function (params) {
              var newParamsName = "";
              var paramsNameNumber = params.length;
              var provideNumber = 7; //一行显示几个字
              var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
              if (paramsNameNumber > provideNumber) {
                for (var p = 0; p < rowNumber; p++) {
                  var tempStr = "";
                  var start = p * provideNumber;
                  var end = start + provideNumber;
                  if (p == rowNumber - 1) {
                    tempStr = params.substring(start, paramsNameNumber);
                  } else {
                    tempStr = params.substring(start, end) + "\n";
                  }
                  newParamsName += tempStr;
                }
              } else {
                newParamsName = params;
              }
              return newParamsName;
            },
          },
          // y轴的颜色和宽度
          // axisLine: {
          //   lineStyle: {
          //     color: "#107D9F",
          //     width: 1, //这里是坐标轴的宽度,可以去掉
          //   },
          // },
        },
        series: [
          {
            type: "bar",
            data: this.lawyer_count,
            showBackground: true,
            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.2)",
            },
            // barWidth: 30, // 柱图宽度
            barMaxWidth: 40, // 最大宽度
            label: {
              //设置柱状图上显示  对应值
              show: true,
              position: "right",
              color: "#606266",
              // color: "#ddb361",
              // show: true,
              // formatter: "{b}   ( {c} 篇)",
              // position: "left",
              // align: "left",
              // offset: [10, 2],
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  // 设置前三个颜色不一样
                  var num = params.value;
                  var djg = params.dataIndex; //第几个数
                  var retcoler = "#345edc";
                  if (djg > 9) {
                    retcoler = "#ef6b59";
                  }
                  return retcoler;
                },
                // barBorderRadius: [0, 8, 8, 0], // 设置柱状图圆角（顺时针左上，右上，右下，左下）
              },
            },
          },
        ],
      };
      briefPie_lawyer.setOption(option, true);
      this.loading_11 = false;
    },
    // 律师
    Briefs_firms() {
      if (this.firms_key.length <= 0) {
        window.document.getElementById("briefPie_firms").style.height = "0px";
      }
      var briefPie_firms = this.$echarts.init(
        window.document.getElementById("briefPie_firms")
      );
      //配置图表
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        toolbox: {
          show: true, //是否显示工具栏
          orient: "horizontal", //工具栏icon的布局朝向‘horizontal’'vertical'
          itemSize: 15, //工具栏icon的大小
          itemGap: 10, //工具栏icon每项之间的间隔
          showTitle: false, //是否在鼠标hover的时候显示每个工具的icon标题
          feature: {
            dataView: {
              show: true,
              readOnly: false,
              lang: ["数据视图", "关闭"], // 这里将刷新改成其他用途
              readOnly: true,
              optionToContent(opt) {
                // console.log(opt);
                // return
                const series = opt.series[0].data; // 折线图数据
                const axisData = opt.yAxis[0].data; // 这里看你放的是x轴还是y轴
                let tdHeads =
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">律所</td>' +
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">数量</td>'; // 表头
                let tdBodys = ""; // 数据
                // series.forEach(function (item) {
                //   // 组装表头
                //   tdHeads +=
                //     '<td style="padding: 0 10px">' + item.name + "</td>";
                // });
                let table =
                  '<table id="exportTab" border="1" style="margin-left:20px;border-collapse:collapse;font-size:14px;text-align:center;margin: auto;width: 80%;"><tbody><tr style:"border-bottom: 1px solid #ebeef5;">' +
                  tdHeads +
                  " </tr>";
                for (let i = 0, l = axisData.length; i < l; i++) {
                  // for (let j = 0; j < series.length; j++) {
                  // 组装表数据
                  tdBodys +=
                    "<td  style='width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;'>" +
                    series[i] +
                    "  </td>";
                  // }
                  table +=
                    '<tr><td style="width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;">' +
                    axisData[i] +
                    "</td>" +
                    tdBodys +
                    "</tr>";
                  tdBodys = "";
                }
                table += "</tbody></table>";
                return table;
              },
              // 重置刷新事件方法
              contentToOption(opt) {
                that.Briefs_firms();
              },
            },
            saveAsImage: {},
          },
        },
        grid: {
          left: "20%",
          // bottom:"35%"
        },
        xAxis: {
          type: "value",

          boundaryGap: [0, 0.01],
        },
        yAxis: {
          show: true,
          // containLabel: true,
          boundaryGap: true,
          type: "category",
          data: this.firms_key,
          // axisLabel: { show: false },

          axisLabel: {
            show: true,
            interval: 0,
            textStyle: {
              fontSize: "12",
              letterSpacing: "2",
            },
            formatter: function (params) {
              var newParamsName = "";
              var paramsNameNumber = params.length;
              var provideNumber = 7; //一行显示几个字
              var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
              if (paramsNameNumber > provideNumber) {
                for (var p = 0; p < rowNumber; p++) {
                  var tempStr = "";
                  var start = p * provideNumber;
                  var end = start + provideNumber;
                  if (p == rowNumber - 1) {
                    tempStr = params.substring(start, paramsNameNumber);
                  } else {
                    tempStr = params.substring(start, end) + "\n";
                  }
                  newParamsName += tempStr;
                }
              } else {
                newParamsName = params;
              }
              return newParamsName;
            },
          },
          // y轴的颜色和宽度
          // axisLine: {
          //   lineStyle: {
          //     color: "#107D9F",
          //     width: 1, //这里是坐标轴的宽度,可以去掉
          //   },
          // },
        },
        series: [
          {
            type: "bar",
            data: this.firms_count,
            showBackground: true,
            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.2)",
            },
            // barWidth: 30, // 柱图宽度
            barMaxWidth: 40, // 最大宽度
            label: {
              //设置柱状图上显示  对应值
              show: true,
              position: "right",
              color: "#606266",
              // color: "#ddb361",
              // show: true,
              // formatter: "{b}   ( {c} 篇)",
              // position: "left",
              // align: "left",
              // offset: [10, 2],
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  // 设置前三个颜色不一样
                  var num = params.value;
                  var djg = params.dataIndex; //第几个数
                  var retcoler = "#345edc";
                  if (djg > 9) {
                    retcoler = "#ef6b59";
                  }
                  return retcoler;
                },
                // barBorderRadius: [0, 8, 8, 0], // 设置柱状图圆角（顺时针左上，右上，右下，左下）
              },
            },
          },
        ],
      };
      briefPie_firms.setOption(option, true);
      this.loading_12 = false;
    },

    // 被告类型
    Paperwork_type_de() {
      if (this.paperCharts_type_de.length <= 0) {
        window.document.getElementById("paperworkPie_type_de").style.height =
          "0px";
      }
      var myPaper_type_de = this.$echarts.init(
        window.document.getElementById("paperworkPie_type_de")
      );
      var option = {
        toolbox: {
          show: true, //是否显示工具栏
          orient: "horizontal", //工具栏icon的布局朝向‘horizontal’'vertical'
          itemSize: 15, //工具栏icon的大小
          itemGap: 10, //工具栏icon每项之间的间隔
          showTitle: false, //是否在鼠标hover的时候显示每个工具的icon标题
          feature: {
            dataView: {
              show: true,
              readOnly: false,
              lang: ["数据视图", "关闭"], // 这里将刷新改成其他用途
              readOnly: true,
              optionToContent(opt) {
                // console.log(opt);
                // return
                // const series = opt.series[0].data; // 折线图数据
                const axisData = opt.series[0].data; // 这里看你放的是x轴还是y轴
                let tdHeads =
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">原告类型</td>' +
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">数量</td>'; // 表头
                let tdBodys = ""; // 数据
                // series.forEach(function (item) {
                //   // 组装表头
                //   tdHeads +=
                //     '<td style="padding: 0 10px">' + item.name + "</td>";
                // });
                let table =
                  '<table id="exportTab" border="1" style="margin-left:20px;border-collapse:collapse;font-size:14px;text-align:center;margin: auto;width: 80%;"><tbody><tr style:"border-bottom: 1px solid #ebeef5;">' +
                  tdHeads +
                  " </tr>";
                for (let i = 0, l = axisData.length; i < l; i++) {
                  // for (let j = 0; j < series.length; j++) {
                  // 组装表数据
                  tdBodys +=
                    "<td  style='width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;'>" +
                    axisData[i].value +
                    " 篇 </td>";
                  // }
                  table +=
                    '<tr><td style="width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;">' +
                    axisData[i].name +
                    "</td>" +
                    tdBodys +
                    "</tr>";
                  tdBodys = "";
                }
                table += "</tbody></table>";
                return table;
              },
              // 重置刷新事件方法
              contentToOption(opt) {
                that.Paperwork_type_de();
              },
            },
            saveAsImage: {},
          },
        },
        title: {
          //   text: "Referer of a Website",
          //   subtext: "Fake Data",
          //   left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          // orient: "vertical",
          // left: "right",
          x: "center",
          y: "bottom",
        },
        series: [
          {
            // name: "Access From",
            type: "pie",
            radius: ["40%", "70%"],
            label: {
              normal: {
                // show: true,
                // position: 'inside',
                formatter: "{b}({d}%)", //模板变量有 {a}、{b}、{c}、{d}，分别表示系列名，数据名，数据值，百分比。{d}数据会根据value值计算百分比
              },
            },
            data: this.paperCharts_type_de,
            // emphasis: {
            //   itemStyle: {
            //     shadowBlur: 10,
            //     shadowOffsetX: 0,
            //     shadowColor: "rgba(0, 0, 0, 0.5)",
            //   },
            // },
          },
        ],
      };
      myPaper_type_de.setOption(option, true);
      this.loading_15 = false;
    },

    // 个人被告
    Briefs_individual_de() {
      if (this.individual_key_de.length <= 0) {
        window.document.getElementById("briefPie_individual_de").style.height =
          "0px";
      }
      var briefPie_individual_de = this.$echarts.init(
        window.document.getElementById("briefPie_individual_de")
      );
      //配置图表
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        toolbox: {
          show: true, //是否显示工具栏
          orient: "horizontal", //工具栏icon的布局朝向‘horizontal’'vertical'
          itemSize: 15, //工具栏icon的大小
          itemGap: 10, //工具栏icon每项之间的间隔
          showTitle: false, //是否在鼠标hover的时候显示每个工具的icon标题
          feature: {
            dataView: {
              show: true,
              readOnly: false,
              lang: ["数据视图", "关闭"], // 这里将刷新改成其他用途
              readOnly: true,
              optionToContent(opt) {
                // console.log(opt);
                // return
                const series = opt.series[0].data; // 折线图数据
                const axisData = opt.yAxis[0].data; // 这里看你放的是x轴还是y轴
                let tdHeads =
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">原告</td>' +
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">数量</td>'; // 表头
                let tdBodys = ""; // 数据
                // series.forEach(function (item) {
                //   // 组装表头
                //   tdHeads +=
                //     '<td style="padding: 0 10px">' + item.name + "</td>";
                // });
                let table =
                  '<table id="exportTab" border="1" style="margin-left:20px;border-collapse:collapse;font-size:14px;text-align:center;margin: auto;width: 80%;"><tbody><tr style:"border-bottom: 1px solid #ebeef5;">' +
                  tdHeads +
                  " </tr>";
                for (let i = 0, l = axisData.length; i < l; i++) {
                  // for (let j = 0; j < series.length; j++) {
                  // 组装表数据
                  tdBodys +=
                    "<td  style='width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;'>" +
                    series[i] +
                    "  </td>";
                  // }
                  table +=
                    '<tr><td style="width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;">' +
                    axisData[i] +
                    "</td>" +
                    tdBodys +
                    "</tr>";
                  tdBodys = "";
                }
                table += "</tbody></table>";
                return table;
              },
              // 重置刷新事件方法
              contentToOption(opt) {
                that.Briefs_individual_de();
              },
            },
            saveAsImage: {},
          },
        },
        grid: {
          // left: "20%",
          // bottom:"35%"
        },
        xAxis: {
          type: "value",

          boundaryGap: [0, 0.01],
        },
        yAxis: {
          show: true,
          containLabel: true,
          boundaryGap: true,
          type: "category",
          data: this.individual_key_de,
          // axisLabel: { show: false },

          axisLabel: {
            show: true,
            interval: 0,
            textStyle: {
              fontSize: "12",
              letterSpacing: "2",
            },
            formatter: function (params) {
              var newParamsName = "";
              var paramsNameNumber = params.length;
              var provideNumber = 10; //一行显示几个字
              var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
              if (paramsNameNumber > provideNumber) {
                for (var p = 0; p < rowNumber; p++) {
                  var tempStr = "";
                  var start = p * provideNumber;
                  var end = start + provideNumber;
                  if (p == rowNumber - 1) {
                    tempStr = params.substring(start, paramsNameNumber);
                  } else {
                    tempStr = params.substring(start, end) + "\n";
                  }
                  newParamsName += tempStr;
                }
              } else {
                newParamsName = params;
              }
              return newParamsName;
            },
          },
          // y轴的颜色和宽度
          // axisLine: {
          //   lineStyle: {
          //     color: "#107D9F",
          //     width: 1, //这里是坐标轴的宽度,可以去掉
          //   },
          // },
        },
        series: [
          {
            type: "bar",
            data: this.individual_count_de,
            showBackground: true,
            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.2)",
            },
            // barWidth: 30, // 柱图宽度
            barMaxWidth: 40, // 最大宽度
            label: {
              //设置柱状图上显示  对应值
              show: true,
              position: "right",
              color: "#606266",
              // color: "#ddb361",
              // show: true,
              // formatter: "{b}   ( {c} 篇)",
              // position: "left",
              // align: "left",
              // offset: [10, 2],
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  // 设置前三个颜色不一样
                  var num = params.value;
                  var djg = params.dataIndex; //第几个数
                  var retcoler = "#345edc";
                  if (djg > 9) {
                    retcoler = "#ef6b59";
                  }
                  return retcoler;
                },
                // barBorderRadius: [0, 8, 8, 0], // 设置柱状图圆角（顺时针左上，右上，右下，左下）
              },
            },
          },
        ],
      };
      briefPie_individual_de.setOption(option, true);
      this.loading_18 = false;
    },

    // 机构被告
    Briefs_institution_de() {
      if (this.institution_key_de.length <= 0) {
        window.document.getElementById("briefPie_institution_de").style.height =
          "0px";
      }
      var briefPie_institution_de = this.$echarts.init(
        window.document.getElementById("briefPie_institution_de")
      );
      //配置图表
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        toolbox: {
          show: true, //是否显示工具栏
          orient: "horizontal", //工具栏icon的布局朝向‘horizontal’'vertical'
          itemSize: 15, //工具栏icon的大小
          itemGap: 10, //工具栏icon每项之间的间隔
          showTitle: false, //是否在鼠标hover的时候显示每个工具的icon标题
          feature: {
            dataView: {
              show: true,
              readOnly: false,
              lang: ["数据视图", "关闭"], // 这里将刷新改成其他用途
              readOnly: true,
              optionToContent(opt) {
                // console.log(opt);
                // return
                const series = opt.series[0].data; // 折线图数据
                const axisData = opt.yAxis[0].data; // 这里看你放的是x轴还是y轴
                let tdHeads =
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">原告</td>' +
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">数量</td>'; // 表头
                let tdBodys = ""; // 数据
                // series.forEach(function (item) {
                //   // 组装表头
                //   tdHeads +=
                //     '<td style="padding: 0 10px">' + item.name + "</td>";
                // });
                let table =
                  '<table id="exportTab" border="1" style="margin-left:20px;border-collapse:collapse;font-size:14px;text-align:center;margin: auto;width: 80%;"><tbody><tr style:"border-bottom: 1px solid #ebeef5;">' +
                  tdHeads +
                  " </tr>";
                for (let i = 0, l = axisData.length; i < l; i++) {
                  // for (let j = 0; j < series.length; j++) {
                  // 组装表数据
                  tdBodys +=
                    "<td  style='width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;'>" +
                    series[i] +
                    "  </td>";
                  // }
                  table +=
                    '<tr><td style="width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;">' +
                    axisData[i] +
                    "</td>" +
                    tdBodys +
                    "</tr>";
                  tdBodys = "";
                }
                table += "</tbody></table>";
                return table;
              },
              // 重置刷新事件方法
              contentToOption(opt) {
                that.Briefs_institution_de();
              },
            },
            saveAsImage: {},
          },
        },
        grid: {
          left: "20%",
          // bottom:"35%"
        },
        xAxis: {
          type: "value",

          boundaryGap: [0, 0.01],
        },
        yAxis: {
          show: true,
          containLabel: true,
          boundaryGap: true,
          type: "category",
          data: this.institution_key_de,
          // axisLabel: { show: false },

          axisLabel: {
            show: true,
            interval: 0,
            textStyle: {
              fontSize: "12",
              letterSpacing: "2",
            },
            formatter: function (params) {
              var newParamsName = "";
              var paramsNameNumber = params.length;
              var provideNumber = 7; //一行显示几个字
              var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
              if (paramsNameNumber > provideNumber) {
                for (var p = 0; p < rowNumber; p++) {
                  var tempStr = "";
                  var start = p * provideNumber;
                  var end = start + provideNumber;
                  if (p == rowNumber - 1) {
                    tempStr = params.substring(start, paramsNameNumber);
                  } else {
                    tempStr = params.substring(start, end) + "\n";
                  }
                  newParamsName += tempStr;
                }
              } else {
                newParamsName = params;
              }
              return newParamsName;
            },
          },
          // y轴的颜色和宽度
          // axisLine: {
          //   lineStyle: {
          //     color: "#107D9F",
          //     width: 1, //这里是坐标轴的宽度,可以去掉
          //   },
          // },
        },
        series: [
          {
            type: "bar",
            data: this.institution_count_de,
            showBackground: true,
            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.2)",
            },
            // barWidth: 30, // 柱图宽度
            barMaxWidth: 40, // 最大宽度
            label: {
              //设置柱状图上显示  对应值
              show: true,
              position: "right",
              color: "#606266",
              // color: "#ddb361",
              // show: true,
              // formatter: "{b}   ( {c} 篇)",
              // position: "left",
              // align: "left",
              // offset: [10, 2],
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  // 设置前三个颜色不一样
                  var num = params.value;
                  var djg = params.dataIndex; //第几个数
                  var retcoler = "#345edc";
                  if (djg > 9) {
                    retcoler = "#ef6b59";
                  }
                  return retcoler;
                },
                // barBorderRadius: [0, 8, 8, 0], // 设置柱状图圆角（顺时针左上，右上，右下，左下）
              },
            },
          },
        ],
      };
      briefPie_institution_de.setOption(option, true);
      this.loading_19 = false;
    },

    // 被告律师
    Briefs_lawyer_de() {
      if (this.lawyer_key_de.length <= 0) {
        window.document.getElementById("briefPie_lawyer_de").style.height =
          "0px";
      }
      var briefPie_lawyer_de = this.$echarts.init(
        window.document.getElementById("briefPie_lawyer_de")
      );
      //配置图表
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        toolbox: {
          show: true, //是否显示工具栏
          orient: "horizontal", //工具栏icon的布局朝向‘horizontal’'vertical'
          itemSize: 15, //工具栏icon的大小
          itemGap: 10, //工具栏icon每项之间的间隔
          showTitle: false, //是否在鼠标hover的时候显示每个工具的icon标题
          feature: {
            dataView: {
              show: true,
              readOnly: false,
              lang: ["数据视图", "关闭"], // 这里将刷新改成其他用途
              readOnly: true,
              optionToContent(opt) {
                // console.log(opt);
                // return
                const series = opt.series[0].data; // 折线图数据
                const axisData = opt.yAxis[0].data; // 这里看你放的是x轴还是y轴
                let tdHeads =
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">律师</td>' +
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">数量</td>'; // 表头
                let tdBodys = ""; // 数据
                // series.forEach(function (item) {
                //   // 组装表头
                //   tdHeads +=
                //     '<td style="padding: 0 10px">' + item.name + "</td>";
                // });
                let table =
                  '<table id="exportTab" border="1" style="margin-left:20px;border-collapse:collapse;font-size:14px;text-align:center;margin: auto;width: 80%;"><tbody><tr style:"border-bottom: 1px solid #ebeef5;">' +
                  tdHeads +
                  " </tr>";
                for (let i = 0, l = axisData.length; i < l; i++) {
                  // for (let j = 0; j < series.length; j++) {
                  // 组装表数据
                  tdBodys +=
                    "<td  style='width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;'>" +
                    series[i] +
                    "  </td>";
                  // }
                  table +=
                    '<tr><td style="width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;">' +
                    axisData[i] +
                    "</td>" +
                    tdBodys +
                    "</tr>";
                  tdBodys = "";
                }
                table += "</tbody></table>";
                return table;
              },
              // 重置刷新事件方法
              contentToOption(opt) {
                that.Briefs_lawyer_de();
              },
            },
            saveAsImage: {},
          },
        },
        grid: {
          left: "20%",
          // bottom:"35%"
        },
        xAxis: {
          type: "value",

          boundaryGap: [0, 0.01],
        },
        yAxis: {
          show: true,
          containLabel: true,
          boundaryGap: true,
          type: "category",
          data: this.lawyer_key_de,
          // axisLabel: { show: false },

          axisLabel: {
            show: true,
            interval: 0,
            textStyle: {
              fontSize: "12",
              letterSpacing: "2",
            },
            formatter: function (params) {
              var newParamsName = "";
              var paramsNameNumber = params.length;
              var provideNumber = 7; //一行显示几个字
              var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
              if (paramsNameNumber > provideNumber) {
                for (var p = 0; p < rowNumber; p++) {
                  var tempStr = "";
                  var start = p * provideNumber;
                  var end = start + provideNumber;
                  if (p == rowNumber - 1) {
                    tempStr = params.substring(start, paramsNameNumber);
                  } else {
                    tempStr = params.substring(start, end) + "\n";
                  }
                  newParamsName += tempStr;
                }
              } else {
                newParamsName = params;
              }
              return newParamsName;
            },
          },
          // y轴的颜色和宽度
          // axisLine: {
          //   lineStyle: {
          //     color: "#107D9F",
          //     width: 1, //这里是坐标轴的宽度,可以去掉
          //   },
          // },
        },
        series: [
          {
            type: "bar",
            data: this.lawyer_count_de,
            showBackground: true,
            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.2)",
            },
            // barWidth: 30, // 柱图宽度
            barMaxWidth: 40, // 最大宽度
            label: {
              //设置柱状图上显示  对应值
              show: true,
              position: "right",
              color: "#606266",
              // color: "#ddb361",
              // show: true,
              // formatter: "{b}   ( {c} 篇)",
              // position: "left",
              // align: "left",
              // offset: [10, 2],
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  // 设置前三个颜色不一样
                  var num = params.value;
                  var djg = params.dataIndex; //第几个数
                  var retcoler = "#345edc";
                  if (djg > 9) {
                    retcoler = "#ef6b59";
                  }
                  return retcoler;
                },
                // barBorderRadius: [0, 8, 8, 0], // 设置柱状图圆角（顺时针左上，右上，右下，左下）
              },
            },
          },
        ],
      };
      briefPie_lawyer_de.setOption(option, true);
      this.loading_16 = false;
    },
    // 被告律所
    Briefs_firms_de() {
      if (this.firms_key_de.length <= 0) {
        window.document.getElementById("briefPie_firms_de").style.height =
          "0px";
      }
      var briefPie_firms_de = this.$echarts.init(
        window.document.getElementById("briefPie_firms_de")
      );
      //配置图表
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        toolbox: {
          show: true, //是否显示工具栏
          orient: "horizontal", //工具栏icon的布局朝向‘horizontal’'vertical'
          itemSize: 15, //工具栏icon的大小
          itemGap: 10, //工具栏icon每项之间的间隔
          showTitle: false, //是否在鼠标hover的时候显示每个工具的icon标题
          feature: {
            dataView: {
              show: true,
              readOnly: false,
              lang: ["数据视图", "关闭"], // 这里将刷新改成其他用途
              readOnly: true,
              optionToContent(opt) {
                // console.log(opt);
                // return
                const series = opt.series[0].data; // 折线图数据
                const axisData = opt.yAxis[0].data; // 这里看你放的是x轴还是y轴
                let tdHeads =
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">律所</td>' +
                  '<td  style="width: 50%;padding: 10px 10px;background: #f5f7fa;border: 1px solid #ebeef5;">数量</td>'; // 表头
                let tdBodys = ""; // 数据
                // series.forEach(function (item) {
                //   // 组装表头
                //   tdHeads +=
                //     '<td style="padding: 0 10px">' + item.name + "</td>";
                // });
                let table =
                  '<table id="exportTab" border="1" style="margin-left:20px;border-collapse:collapse;font-size:14px;text-align:center;margin: auto;width: 80%;"><tbody><tr style:"border-bottom: 1px solid #ebeef5;">' +
                  tdHeads +
                  " </tr>";
                for (let i = 0, l = axisData.length; i < l; i++) {
                  // for (let j = 0; j < series.length; j++) {
                  // 组装表数据
                  tdBodys +=
                    "<td  style='width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;'>" +
                    series[i] +
                    "  </td>";
                  // }
                  table +=
                    '<tr><td style="width: 50%;padding: 10px 10px ;border: 1px solid #ebeef5;">' +
                    axisData[i] +
                    "</td>" +
                    tdBodys +
                    "</tr>";
                  tdBodys = "";
                }
                table += "</tbody></table>";
                return table;
              },
              // 重置刷新事件方法
              contentToOption(opt) {
                that.Briefs_firms_de();
              },
            },
            saveAsImage: {},
          },
        },
        grid: {
          left: "20%",
          // bottom:"35%"
        },
        xAxis: {
          type: "value",

          boundaryGap: [0, 0.01],
        },
        yAxis: {
          show: true,
          // containLabel: true,
          boundaryGap: true,
          type: "category",
          data: this.firms_key_de,
          // axisLabel: { show: false },

          axisLabel: {
            show: true,
            interval: 0,
            textStyle: {
              fontSize: "12",
              letterSpacing: "2",
            },
            formatter: function (params) {
              var newParamsName = "";
              var paramsNameNumber = params.length;
              var provideNumber = 7; //一行显示几个字
              var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
              if (paramsNameNumber > provideNumber) {
                for (var p = 0; p < rowNumber; p++) {
                  var tempStr = "";
                  var start = p * provideNumber;
                  var end = start + provideNumber;
                  if (p == rowNumber - 1) {
                    tempStr = params.substring(start, paramsNameNumber);
                  } else {
                    tempStr = params.substring(start, end) + "\n";
                  }
                  newParamsName += tempStr;
                }
              } else {
                newParamsName = params;
              }
              return newParamsName;
            },
          },
          // y轴的颜色和宽度
          // axisLine: {
          //   lineStyle: {
          //     color: "#107D9F",
          //     width: 1, //这里是坐标轴的宽度,可以去掉
          //   },
          // },
        },
        series: [
          {
            type: "bar",
            data: this.firms_count_de,
            showBackground: true,
            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.2)",
            },
            // barWidth: 30, // 柱图宽度
            barMaxWidth: 40, // 最大宽度
            label: {
              //设置柱状图上显示  对应值
              show: true,
              position: "right",
              color: "#606266",
              // color: "#ddb361",
              // show: true,
              // formatter: "{b}   ( {c} 篇)",
              // position: "left",
              // align: "left",
              // offset: [10, 2],
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  // 设置前三个颜色不一样
                  var num = params.value;
                  var djg = params.dataIndex; //第几个数
                  var retcoler = "#345edc";
                  if (djg > 9) {
                    retcoler = "#ef6b59";
                  }
                  return retcoler;
                },
                // barBorderRadius: [0, 8, 8, 0], // 设置柱状图圆角（顺时针左上，右上，右下，左下）
              },
            },
          },
        ],
      };
      briefPie_firms_de.setOption(option, true);
      this.loading_17 = false;
    },
  },
  watch: {
    // 监听父组件传参变化重新赋值
    eChars(val) {
      // console.log('1')
      this.dataCharts = val;
    },
  },
  mounted() {
    // return

    this.myEcharts();
    this.myTrials();
    // this.myshenli();
    this.myPaperwork();
    this.myPaperwork_case();
    this.myBriefs();
    this.myLevel();

    this.regional_map();

    // this.myBriefs0();
    // this.loading = false;
    // this.myRadars();
    // let _this = this;
    // window.onresize = function () {
    //   this.myTrials.resize();
    // };
  },
  components: {
    Map,
  },
};
</script>

<style  lang="less" scoped>
.tsg_s {
  padding: 0 20px;
}
.chart {
  // margin: 10px 0 20px 0px;
  // padding: 10px;
  background: #fbf2eb;
  min-height: 775px;
  .caseType {
    display: flex;
    justify-content: space-around;
    margin: 10px 0;
    // background: white;
    background: #fbf2eb;
    padding: 10px 0;
    border-radius: 10px;
    .case {
      width: 120px;
      p {
        text-align: center;
      }
      img {
        width: 50px;
        margin: 10px 35px;
      }
    }
  }
  .YearLine {
    // background: white;
    background: #fbf2eb;
    padding: 10px 50px;
    border-radius: 10px;
    .yearsTitle {
      display: flex;
      justify-content: space-between;
      h3 {
        display: inline-block;
        font-size: 18px;
        font-weight: 600;
        line-height: 40px;
      }
      .fivePick {
        // color: #409eff;
        // background: #ecf5ff;
        // border-color: #b3d8ff;
        color: #ddb361;
        background: #faf1ea;
        border-color: #ddb361;
      }
      .threePick {
        // background: #fff;
        // border: 1px solid #dcdfe6;
        // color: #606266;
        // color: #ddb361;
        background: none !important;
        border: 1px solid #c0bbb0;
      }
      .el-button:hover {
        // color: #409eff;
        // border-color: #c6e2ff;
        // background-color: #ecf5ff;
        color: #ddb361;
        background: #faf1ea;
        border-color: #ddb361;
      }
    }
  }
  .procedural {
    margin: 20px 0;
    display: flex;
    justify-content: space-between;
    .trial,
    .paperwork,
    .reference,
    .brief {
      width: 48%;
      // background: white;
      background: #fbf2eb;
      padding: 10px 10px;
      border-radius: 10px;
    }
  }
  .bid {
    // background: white;
    background: #fbf2eb;
    padding: 10px 10px;
    border-radius: 10px;
    margin: 0 0 20px 0;
  }
}
/deep/ .el-divider--horizontal {
  margin: 10px 0;
  color: #e7f7a4;
}
.trialTitle {
  display: flex;
  justify-content: space-between;
  h3 {
    display: inline-block;
    font-size: 18px;
    font-weight: 600;
    line-height: 40px;
  }
  img {
    width: 24px;
    margin: 8px;
    cursor: pointer;
    transition: all 0.6s;
  }
  img:hover {
    transform: scale(1.4);
  }
  .zhu {
    width: 100%;
    height: 400px;
  }
  .zhe {
    width: 0;
    height: 0;
  }
}
#paperworkPie01 {
  // position: relative;
  // top: -400px;
  // z-index: 100000000;
}

.buttons {
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  .el-button {
    color: #000000;
    border: 1px solid #ddb361;
  }
  .el-button:hover {
    color: #ddb361;
    background: #faf1ea;
    border-color: #ddb361;
  }
}
.chosen {
  color: #000000;
  background: #faf1ea;
  border-color: #ddb361;
  // letterSpacing: ;
  // text-align: center;
  // color: #9e3362;
  // color: #65364e;
  // color: #493745;
  // color: #7bb5e4;
  // color: #3463bb;
  // color: #0b3068;
  // margin: auto;width: 50%;
}
.map_return {
  position: absolute;
  right: 30px;
  display: inline-block;
}
.el-divider {
  width: 50%;
  background-color: #ddb361;
  height: 2px;
  /deep/ .el-divider__text {
    padding: 0;
  }
}
.tit_type {
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 1px;
  display: inline-block;
  padding: 0 15px;
  background: #fbf2eb;
}
#trialBar {
  /deep/ div {
    // width: 493px !important;
  }
}
</style>